import { useFieldArray, useForm } from "react-hook-form";
import cargoDetail from "../assets/images/worldwide-shipping.svg";
import LabeledTextField from "../mui-components/LabeledTextField";
import { Columns, Col12 } from "../Controls.js";
import { useSnapshot } from "valtio";
import { AgmodalStore, aguserStore, configStore, EntityV2Store } from "../state/CommonState";
import { useEffect, useRef, useState } from "react";
import { AgUnlocCH } from "../components/AgComponents.js";
import { getHazardousClassList } from "../StaticData.js";
import { ActiveTabCH } from "../v3-componets/AgActiveTab.js";

import { Cargo, enquiryStore } from "../enquiry/enquiry-data";
import { AgMuiUn } from "../mui-components/AgAutoComplete.js";
import {
  lclWeightForPort,
  maxDimensions,
  packageTypeList,
  weightPerPackage,
} from "../StaticData";
import { Quantity } from "../tailwind-components/Quantity";
import { TextWithSelect } from "../mui-components/TextWithSelect";
import { AgMuiSelect2 } from "../mui-components/Controlled";
import deleteicon from "../assets/images/deletei.svg";
import Utils from "../util/Utils";
import { FlexibleCenteredDiv } from "../v3-componets/AgFlexibleCenteredDiv.js";
import { TableHeading } from "../v3-componets/AgTableHeading.js";
import { HeadingWithSelect } from "../v3-componets/AgHeadingWithSelect.js";
import { Add } from "@mui/icons-material";
import { DetailsText3 } from "../mui-components/DetailsText.js";
import { DetailsSelect2 } from "../mui-components/DetailsSelect.js";
import { ControlledDetailSwitch } from "../v3-componets/AgControlledDetailSwitch.js";
import { cartingStore } from "./cartingStore.js";
import { Headspan } from "../v3-componets/AgHeadspan.js";
import CartingOrderApi from "../state/cartingorder-api.js";
import { loader } from "../util/loader.js";
import { AgCustlistCH, AgSelectLatestCH, AgSelectNewCH } from "../components/AgCustlist.js";
import { AgCustomFile, AgCustomFileMobile } from "../components/AgFile.js";
import { FileViewComponent } from "../mui-components/FileComponent.js";
import { $c } from '../components/AgComponents.js'
import AguserApi from "../state/AguserApi.js";
import EntityV2Api from "../state/entities-api.js";
import EntityApi from "../state/entity-api.js";
import { Autocomplete, TextField, Typography,Grid, Box } from "@mui/material";
import { CustomStyledTextField } from "../mui-components/ColoredTextfield.js";
import { OneDateTime, OneDateTime1 } from "../mytasks/act-common.js";
import Api from "../state/Api.js";
import { useMobile } from "../hooks/usemobile";

function MobileSectionHeader({ index, title, subtitle, isCompleted, isOptional, rightElement }) {
  return (
    <div className="flex flex-row justify-between items-center w-full py-2.5  bg-white mb-3">
      <div className="flex flex-row items-center gap-3 flex-1 min-w-0">
        {/* Leading Widget (Tick or Numbered box) */}
        {isCompleted ? (
          <div className="w-9 h-9 rounded-xl bg-[#E9F9DC] flex items-center justify-center text-[#15803D] shrink-0">
            <svg className="w-5 h-5 stroke-[2.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        ) : (
          <div className="w-9 h-9 rounded-xl bg-[#FFEDD5] flex items-center justify-center text-[#C2410C] font-bold text-sm shrink-0">
            {index}
          </div>
        )}

        {/* Title & Subtitle */}
        <div className="flex flex-col flex-1 min-w-0">
          <h3 className="font-bold text-sm text-[#1E293B] leading-tight truncate">
            {title}
          </h3>
          {subtitle && (
            <p className="text-[11px] text-[#64748B] font-normal leading-tight mt-0.5 truncate">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Trailing Action / Chip */}
      <div className="flex flex-row items-center gap-2 shrink-0 ml-2">
        {rightElement}
        {isCompleted ? (
          <span className="px-2.5 py-1 rounded-lg bg-[#E9F9DC] text-[#2E7D32] font-semibold text-[11px]">
            Done
          </span>
        ) : isOptional ? (
          <span className="px-2.5 py-1 rounded-lg bg-[#F1F5F9] text-[#64748B] font-semibold text-[11px]">
            Optional
          </span>
        ) : (
          <span className="px-2.5 py-1 rounded-lg bg-[#FFEDD5] text-[#C2410C] font-semibold text-[11px]">
            Required
          </span>
        )}
      </div>
    </div>
  );
}

export function MobileTopSummaryCard({
  cartingId,
  mode,
  pol,
  pod,
  completedCount,
  totalSections = 7,
  onClose
}) {
  const percentage = Math.round((completedCount / totalSections) * 100);

  return (
    <div className="w-full bg-white rounded-2xl p-4 border border-gray-100 shadow-sm">
      {/* Top Header Row: Label, ID, Close Icon */}
      <div className="flex flex-row justify-between items-start">
        <div className="flex flex-col">
          <span className="text-[16px] font-bold text-[#2C358A] tracking-wider">
            Carting Sheet
          </span>
         {cartingId && <h2 className="text-lg sm:text-xl font-extrabold text-[#2C358A] leading-tight mt-0.5">
            {cartingId }
          </h2>}
        </div>

        {/* Circular Close Icon (X) */}
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full border-0 flex items-center justify-center text-gray-500 hover:bg-gray-100 active:scale-95 transition-all shrink-0 cursor-pointer"
            aria-label="Close and back to upload"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Divider */}
      <div className="w-full h-[1px] bg-gray-100 my-3" />

      {/* Details Row: Mode, POL, POD */}
      <div className="flex flex-row items-center flex-wrap gap-x-4 gap-y-1 text-xs text-[#64748B] mb-3">
        <div>
          <span>Mode </span>
          <strong className="text-[#1E293B] font-semibold">{mode || "LCL"}</strong>
        </div>
        {pol && (
          <div>
            <span>POL </span>
            <strong className="text-[#1E293B] font-semibold">{pol}</strong>
          </div>
        )}
        {pod && (
          <div>
            <span>POD </span>
            <strong className="text-[#1E293B] font-semibold">{pod}</strong>
          </div>
        )}
      </div>

      {/* Progress Bar Header & Track */}
      <div className="flex flex-col gap-1.5">
        <div className="flex flex-row justify-between items-center text-xs font-semibold text-[#D97706]">
          <span>{completedCount} of {totalSections} sections complete</span>
          <span>{percentage}%</span>
        </div>

        {/* Progress Track */}
        <div className="w-full h-2 rounded-full bg-[#F3F4F6] overflow-hidden">
          <div
            className="h-full rounded-full bg-[#D97706] transition-all duration-300 ease-out"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
}

function ShippingDetailsSwitches({
  control,
  register,
  nomination,
  bankInvolved,
  handleNominationChange,
  disable,
  isMobile = false
}) {
  if (isMobile) {
    return (
      <div className="flex flex-row w-full gap-3 border-t border-gray-100">
        <div className="flex flex-row justify-between items-center w-full py-1">
          <span className="font-semibold text-sm text-[#1E293B]">Nomination</span>
          <ControlledDetailSwitch
            control={control}
            isChecked={nomination}
            register={register}
            formKey={"nomination"}
            title={""}
            disable={disable}
            onChange={(value) => {
              if (handleNominationChange) handleNominationChange(value);
            }}
          />
        </div>
        <div className="flex flex-row justify-between items-center w-full py-1">
          <span className="font-semibold text-sm text-[#1E293B] whitespace-nowrap">Bank Involved</span>
          <ControlledDetailSwitch
            control={control}
            isChecked={bankInvolved}
            register={register}
            formKey={"bankInvolved"}
            title={""}
            disable={disable}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-row gap-[10px]">
        <ControlledDetailSwitch
          control={control}
          isChecked={nomination}
          register={register}
          formKey={"nomination"}
          title={"Nomination"}
          disable={disable}
          onChange={(value) => {
            if (handleNominationChange) handleNominationChange(value);
          }}
        />
      </div>
      <div className="flex flex-row gap-[10px]">
        <ControlledDetailSwitch
          control={control}
          isChecked={bankInvolved}
          register={register}
          formKey={"bankInvolved"}
          title={"Bank Involved"}
          disable={disable}
        />
      </div>
    </>
  );
}

export function MobileShipmentTypeTab({ selectedType, callback, viewonly = false }) {
  const options = ["LCL", "FCL", "AIR"];

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <span className="text-xs font-semibold text-[#64748B]">Shipment Type</span>
      <div className="inline-flex flex-row border border-black rounded-md overflow-hidden bg-white w-fit shadow-xs px-1">
        {options.map((type) => {
          const isSelected =
            String(type).toLowerCase() === String(selectedType || "lcl").toLowerCase();
          return (
            <button
              key={type}
              type="button"
              onClick={() => {
                if (!viewonly && callback) {
                  callback(type === "AIR" ? "Air" : type);
                }
              }}
              className={`px-4 py-2 text-xs font-bold uppercase transition-colors border-r  border-gray-200 cursor-pointer ${
                isSelected
                  ? "bg-[#2B3990] text-white"
                  : "bg-white text-[#475569] hover:bg-gray-50"
              }`}
            >
              {type}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function CargoAttributesSwitches({
  isMobile,
  control,
  register,
  disable,
  attributes = {},
}) {
  const items = [
    { formKey: "reefer", title: "Reefer", isChecked: attributes.reefer },
    { formKey: "overHeight", title: "Over Height", isChecked: attributes.overHeight },
    { formKey: "overlength", title: "Over length", isChecked: attributes.overlength },
    { formKey: "topLoading", title: "Top Loading", isChecked: attributes.topLoading },
    { formKey: "fumigation", title: "Fumigation", isChecked: attributes.fumigation },
    { formKey: "headLoad", title: "Head Load", isChecked: attributes.headLoad },
    { formKey: "doorLoad", title: "Door Load", isChecked: attributes.doorLoad },
    { formKey: "hazardous", title: "Hazardous", isChecked: attributes.hazardous },
    { formKey: "nonStackable", title: "Non-Stackable", isChecked: attributes.nonStackable },
  ];

  if (isMobile) {
    return (
      <div className="flex flex-col w-full gap-3">
        <span className="text-xs font-semibold text-[#64748B]">Cargo Attributes</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-3.5 items-center w-full">
          {items.map((item, idx) => (
            <div
              key={item.formKey}
              className={`flex flex-row justify-between items-center pr-1 ${
                idx === items.length - 1 ? "col-span-2 sm:col-span-1" : ""
              }`}
            >
              <ControlledDetailSwitch
                control={control}
                isChecked={item.isChecked}
                register={register}
                formKey={item.formKey}
                title={item.title}
                disable={disable}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-row justify-between items-center">
      {items.map((item) => (
        <div key={item.formKey} className="flex flex-row gap-[10px]">
          <ControlledDetailSwitch
            control={control}
            isChecked={item.isChecked}
            register={register}
            formKey={item.formKey}
            title={item.title}
            disable={disable}
          />
        </div>
      ))}
    </div>
  );
}

export function MobileRequiredDocumentsView({
  cartingStore,
  filecat,
  delFile,
  renderLink,
  fetchshippingBillchecklist,
}) {
  return (
    <div className="flex flex-col w-full gap-4">
      {/* Commercial Invoice */}
      <div className="border border-[#E2E8F0] rounded-xl  bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
        <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
          Commercial Invoice
        </div>
        <div className="flex flex-row flex-wrap items-center gap-2 flex-1 sm:w-auto">
          <AgCustomFileMobile
            source="cartingorder"
            cat={filecat}
            filetype="commercialInvoice"
            parent="co1"
            multi={true}
            multiple={true}
            title=""
            lisFiles={true}
            data={cartingStore?.current?.commercialInvoice_filename_list || []}
            callback={(filename) => {
              if (!cartingStore.current.commercialInvoice_filename_list) {
                cartingStore.current.commercialInvoice_filename_list = [];
              }
              cartingStore.current.commercialInvoice_filename_list = [
                ...cartingStore.current.commercialInvoice_filename_list,
                filename,
              ];
            }}
            onFileDeleted={(file, success) => {
              const updated = delFile(
                cartingStore.current.commercialInvoice_filename_list,
                cartingStore.current.commercialInvoice_filename_list.indexOf(file)
              );
              cartingStore.current.commercialInvoice_filename_list = [...updated];
              if (success) success();
            }}
          />
        </div>
      </div>

      {/* Packing List */}
      <div className="border border-[#E2E8F0] rounded-xl  bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
        <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
          Packing List
        </div>
        <div className="flex flex-row flex-wrap items-center gap-2 flex-1 sm:w-auto">
          <AgCustomFileMobile
            source="cartingorder"
            cat={filecat}
            filetype="packingList"
            parent="co2"
            multi={true}
            multiple={true}
            title=""
            lisFiles={true}
            data={cartingStore?.current?.packingList_filename_list || []}
            callback={(filename) => {
              if (!cartingStore.current.packingList_filename_list) {
                cartingStore.current.packingList_filename_list = [];
              }
              cartingStore.current.packingList_filename_list = [
                ...cartingStore.current.packingList_filename_list,
                filename,
              ];
            }}
            onFileDeleted={(file, success) => {
              const updated = delFile(
                cartingStore.current.packingList_filename_list,
                cartingStore.current.packingList_filename_list.indexOf(file)
              );
              cartingStore.current.packingList_filename_list = [...updated];
              if (success) success();
            }}
          />
        </div>
      </div>

      {/* Shipping Bill */}
      <div className="border border-[#E2E8F0] rounded-xl  bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
        <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
          Shipping Bill
        </div>
        <div className="flex flex-row flex-wrap items-center gap-2 flex-1 sm:w-auto">
          <AgCustomFileMobile
            source="cartingorder"
            cat={filecat}
            filetype="shippingBill"
            parent="co3"
            multi={true}
            multiple={true}
            title=""
            lisFiles={true}
            data={cartingStore?.current?.shippingBill_filename_list || []}
            callback={(filename) => {
              if (!cartingStore.current.shippingBill_filename_list) {
                cartingStore.current.shippingBill_filename_list = [];
              }
              cartingStore.current.shippingBill_filename_list = [
                ...cartingStore.current.shippingBill_filename_list,
                filename,
              ];
            }}
            onFileDeleted={(file, success) => {
              const updated = delFile(
                cartingStore.current.shippingBill_filename_list,
                cartingStore.current.shippingBill_filename_list.indexOf(file)
              );
              cartingStore.current.shippingBill_filename_list = [...updated];
              if (success) success();
            }}
          />
        </div>
      </div>

      {/* Carting Photos */}
      {cartingStore?.current?.cartingPhotos_filename_list !== undefined && (
        <div className="border border-[#E2E8F0] rounded-xl  bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
          <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
            Carting Photos
          </div>
          <div className="flex flex-row flex-wrap items-center gap-2 flex-1 sm:w-auto">
            <AgCustomFileMobile
              source="cartingorder"
              cat={filecat}
              filetype="cartingPhotos"
              parent="co4"
              multi={true}
              multiple={true}
              title=""
              lisFiles={true}
              data={cartingStore?.current?.cartingPhotos_filename_list || []}
              callback={(filename) => {
                if (!cartingStore.current.cartingPhotos_filename_list) {
                  cartingStore.current.cartingPhotos_filename_list = [];
                }
                cartingStore.current.cartingPhotos_filename_list = [
                  ...cartingStore.current.cartingPhotos_filename_list,
                  filename,
                ];
              }}
              onFileDeleted={(file, success) => {
                const updated = delFile(
                  cartingStore.current.cartingPhotos_filename_list,
                  cartingStore.current.cartingPhotos_filename_list.indexOf(file)
                );
                cartingStore.current.cartingPhotos_filename_list = [...updated];
                if (success) success();
              }}
            />
          </div>
        </div>
      )}

      {/* MM Slip */}
      {cartingStore?.current?.mmSlip_filename_list !== undefined && (
        <div className="border border-[#E2E8F0] rounded-xl  bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
          <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
            MM Slip
          </div>
          <div className="flex flex-row flex-wrap items-center gap-2 flex-1 sm:w-auto">
            <AgCustomFileMobile
              source="cartingorder"
              cat={filecat}
              filetype="mmSlip_filename"
              parent="co5"
              multi={true}
              multiple={true}
              title=""
              lisFiles={true}
              data={cartingStore?.current?.mmSlip_filename_list || []}
              callback={(filename) => {
                if (!cartingStore.current.mmSlip_filename_list) {
                  cartingStore.current.mmSlip_filename_list = [];
                }
                cartingStore.current.mmSlip_filename_list = [
                  ...cartingStore.current.mmSlip_filename_list,
                  filename,
                ];
              }}
              onFileDeleted={(file, success) => {
                const updated = delFile(
                  cartingStore.current.mmSlip_filename_list,
                  cartingStore.current.mmSlip_filename_list.indexOf(file)
                );
                cartingStore.current.mmSlip_filename_list = [...updated];
                if (success) success();
              }}
            />
          </div>
        </div>
      )}

      {/* Shipping Bill CheckList (View Only - No Upload Button & Non-Deletable) */}
      {cartingStore?.current?.shippingBillchecklist_filename_list !== undefined && (
        <div className="border border-[#E2E8F0] rounded-xl bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 shadow-xs w-full">
          <div className="w-full sm:w-auto font-semibold text-xs text-[#1E293B] min-w-[140px]">
            Shipping Bill CheckList
          </div>
          <div className="flex flex-row flex-wrap items-center gap-2 flex-1 w-full sm:w-auto overflow-hidden">
            {cartingStore?.current?.shippingBillchecklist_filename_list &&
            cartingStore.current.shippingBillchecklist_filename_list.length > 0 ? (
              <div className="flex flex-col gap-1.5 w-full overflow-hidden">
                {cartingStore.current.shippingBillchecklist_filename_list.map((file, idx) => (
                  <FileViewComponent
                    key={idx}
                    documentTitle={file}
                    documentUrl={`${process.env.REACT_APP_FILE_SERVER}/clientfiles/${file}`}
                    isDeletable={false}
                    width="100%"
                    height="40px"
                  />
                ))}
              </div>
            ) : (
              <span className="text-xs text-[#94A3B8] italic">No document uploaded</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export function MobileCargoDetailsView({
  control,
  register,
  getValues,
  setValue,
  watch,
  errors,
  mode,
  cartingStore,
  reefer,
  overHeight,
  overlength,
  topLoading,
  fumigation,
  headLoad,
  doorLoad,
  hazardous,
  nonStackable,
  cargodetailsFromForm = [],
  cargoDetails = [],
  appendCargo,
  removeCargo,
  total = {},
  isDimension,
  weight,
  totalWeight,
  totalVolume,
  dimensionsUnit,
  generateId,
  validateGreaterThanZero,
  calculateWeightAndVolume,
  LabelStyle,
  DimensionLabelStyle,
}) {
  const optionsList = ["Kgs", "Tons", "Lbs"];
  const volumeOptionsList = ["CBM", "cu ft"];

  return (
    <div className="flex flex-col w-full gap-5">
      {/* Net Weight Input */}
      

      {/* Cargo Attributes */}
      <CargoAttributesSwitches
        isMobile={true}
        control={control}
        register={register}
        disable={cartingStore?.disable}
        attributes={{
          reefer,
          overHeight,
          overlength,
          topLoading,
          fumigation,
          headLoad,
          doorLoad,
          hazardous,
          nonStackable,
        }}
      />

      {/* Conditional Attribute Fields */}
      {(hazardous || overHeight || overlength) && (
        <div className="w-full flex flex-col gap-2.5 pt-1">
          {hazardous && (
            <DetailsSelect2
              control={control}
              name={"quoteClass"}
              label={"Class *"}
              options={getHazardousClassList(mode?.toUpperCase() || "LCL")}
              disabled={cartingStore?.disable}
            />
          )}
          {hazardous && (
            <DetailsText3
              disabled={cartingStore?.disable}
              label={"UN Number *"}
              fontSize="12px"
              size="small"
              fullwidth
              control={control}
              name={"unnumber"}
              type="text"
            />
          )}
          {overHeight && (
            <DetailsText3
              disabled={cartingStore?.disable}
              label={"Over Height *"}
              fontSize="12px"
              size="small"
              fullwidth
              control={control}
              name={"overHeightValue"}
            />
          )}
          {overlength && (
            <DetailsText3
              disabled={cartingStore?.disable}
              label={"Over Length *"}
              fontSize="12px"
              size="small"
              fullwidth
              control={control}
              name={"overlengthValue"}
            />
          )}
        </div>
      )}

      {/* Units Box (Applied to all Rows) */}
      {/* <div className="border border-[#E2E8F0] rounded-xl bg-white flex flex-col gap-2.5 w-full shadow-xs">
        <span className="text-[11px] font-bold text-[#2B3990] uppercase tracking-wide">
          UNITS <span className="font-normal text-[#64748B] normal-case">(Applied to all Rows)</span>
        </span>
        <div className="grid grid-cols-2 gap-3 w-full">
          
          <div className="flex flex-col gap-1 w-full">
            <span className="text-xs font-semibold text-[#1E293B]">Weight Unit*</span>
            <AgMuiSelect2
              disabled={cartingStore?.disable && !cartingStore?.update}
              control={control}
              name={isDimension ? `cargoDetails.0.weight.unit` : `cargoDetails.0.totalWeight.unit`}
              options={optionsList}
              values={optionsList}
              size="small"
              fontSize="13px"
              width="100%"
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </div>

          
          <div className="flex flex-col gap-1 w-full">
            <span className="text-xs font-semibold text-[#1E293B]">
              Volume Unit*
            </span>
            {isDimension ? (
              <AgMuiSelect2
                disabled={cartingStore?.disable && !cartingStore?.update}
                control={control}
                name={"cargoDimensionUnit"}
                options={["Cms", "MM", "Inches", "Meters", "Feet"]}
                values={["Cms", "MM", "Inches", "Meters", "Feet"]}
                size="small"
                fontSize="13px"
                width="100%"
                style={{ width: "100%", borderRadius: "8px" }}
              />
            ) : (
              <AgMuiSelect2
                disabled={cartingStore?.disable && !cartingStore?.update}
                control={control}
                name={`cargoDetails.0.totalVolume.unit`}
                options={volumeOptionsList}
                values={volumeOptionsList}
                onChangeHandler={() => {
                  if (calculateWeightAndVolume) calculateWeightAndVolume();
                }}
                size="small"
                fontSize="13px"
                width="100%"
                style={{ width: "100%", borderRadius: "8px" }}
              />
            )}
          </div>
        </div>
      </div> */}

      {/* Package Lines */}
      <div className="flex flex-col w-full gap-3">
        {cargodetailsFromForm.map((cargodetail, i) => (
          <div
            key={generateId(cargodetail.id, i)}
            className="border border-[#E2E8F0] rounded-2xl bg-white flex flex-col gap-3 relative shadow-xs"
          >
            {/* Row Header: Row Index & Red Delete Icon Button */}
            <div className="flex flex-row justify-between items-center w-full pb-1">
              <span className="font-bold text-sm text-blue-dark">Row {i + 1}</span>
              {(cartingStore?.disable === false || cartingStore?.update === true) && cargodetailsFromForm.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeCargo(i)}
                  className="w-7 h-7 rounded-lg bg-[#FFEDED] border-0 border-[#FFCACA] flex items-center justify-center cursor-pointer hover:bg-[#FFE0E0] transition-colors"
                >
                  <img src={deleteicon} alt="Delete" className="w-3.5 h-3.5" />
                </button>
              )}
            </div>

            {/* Package Type & Quantity (60:40 Ratio) */}
            <div className="flex flex-row w-full gap-3 items-end">
              <div className="flex flex-col gap-1 w-[60%]">
                <span className="text-xs font-semibold text-[#64748B]">Package Type</span>
                <AgMuiSelect2
                  disabled={cartingStore?.disable && !cartingStore?.update}
                  getValues={getValues}
                  key={generateId(cargodetail.id, i)}
                  width="100%"
                  style={{ height: "25px", width: "100%", maxWidth: "100%" }}
                  onChangeHandler={() => {}}
                  onBlur={() => {}}
                  rules={{ required: "Required" }}
                  size="small"
                  fontSize="12px"
                  values={packageTypeList}
                  options={packageTypeList}
                  control={control}
                  name={`cargoDetails.${i}.packageType`}
                />
              </div>
              <div className="flex flex-col gap-1 w-[40%]">
                <span className="text-xs font-semibold text-[#64748B]">Quantity</span>
                <Quantity
                  disabled={cartingStore?.disable && !cartingStore?.update}
                  onChange={() => {}}
                  getValues={getValues}
                  key={generateId(cargodetail.id, i)}
                  callback={(e) => {
                    setValue(`cargoDetails.${i}.quantity`, e);
                  }}
                  control={control}
                  name={`cargoDetails.${i}.quantity`}
                  rules={{
                    required: "Required",
                    validate: validateGreaterThanZero,
                  }}
                />
              </div>
            </div>

            {/* Total Weight & Total Volume */}
            <div className="grid grid-cols-2 gap-3 w-full items-end">
              <div className="flex flex-col gap-1 w-full">
                <span className="text-xs font-semibold text-[#64748B]">Total Weight</span>
                {isDimension ? (
                  <TextWithSelect
                    disabled={cartingStore?.disable && !cartingStore?.update}
                    onChange={() => {}}
                    getValues={getValues}
                    key={generateId(cargodetail.id, i)}
                    name={`cargoDetails.${i}.weight.value`}
                    control={control}
                    unit={mode === "air" ? weight : totalWeight}
                    rules={{ required: "Required" }}
                  />
                ) : (
                  <TextWithSelect
                    textFieldWidth="100%"
                    disabled={cartingStore?.disable && !cartingStore?.update}
                    onChange={() => {}}
                    getValues={getValues}
                    unit={totalWeight}
                    key={generateId(cargodetail.id, i)}
                    options={optionsList}
                    control={control}
                    name={`cargoDetails.${i}.totalWeight.value`}
                    selectName={`cargoDetails.0.totalWeight.unit`}
                     rules={{
                              required: "Required",
                              validate: (value) => {
                                let isValue = validateGreaterThanZero(value);
                                const totalWeight = getValues(
                                  `cargoDetails.0.totalWeight.unit`
                                );
                                if (typeof isValue === "string") {
                                  return isValue;
                                } else if (mode !== "fcl") {
                                  return;
                                  let l = Utils.toNum(cargodetail.quantity);
                                  if (l > 0) {
                                    let maxValue =
                                      l *
                                      weightPerPackage[mode][
                                        totalWeight.toLowerCase()
                                      ];
                                    if (parseFloat(value) > maxValue) {
                                      // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                      return `value can't be greater than ${
                                        maxValue + " " + totalWeight
                                      } `;
                                    }
                                  }
                                }
                              },
                            }}
                  />
                )}
              </div>
              <div className="flex flex-col gap-1 w-full">
                <span className="text-xs font-semibold text-[#64748B]">Total Volume</span>
                {isDimension ? (
                  <div className="flex flex-row gap-1 items-center">
                    <LabeledTextField
                      disabled={cartingStore?.disable}
                      textfieldStyles={DimensionLabelStyle}
                      control={control}
                      name={`cargoDetails.${i}.dimensions.length`}
                      endAdornment={<div className={LabelStyle}>L</div>}
                    />
                    <span className="text-xs font-bold text-[#64748B]">x</span>
                    <LabeledTextField
                      disabled={cartingStore?.disable}
                      textfieldStyles={DimensionLabelStyle}
                      control={control}
                      name={`cargoDetails.${i}.dimensions.width`}
                      endAdornment={<div className={LabelStyle}>W</div>}
                    />
                    <span className="text-xs font-bold text-[#64748B]">x</span>
                    <LabeledTextField
                      disabled={cartingStore?.disable}
                      textfieldStyles={DimensionLabelStyle}
                      control={control}
                      name={`cargoDetails.${i}.dimensions.height`}
                      endAdornment={<div className={LabelStyle}>H</div>}
                    />
                  </div>
                ) : (
                  <TextWithSelect
                   textFieldWidth="100%"
                    disabled={cartingStore?.disable && !cartingStore?.update}
                    onChange={() => {}}
                    getValues={getValues}
                    unit={totalVolume}
                    key={generateId(cargodetail.id, i)}
                    options={volumeOptionsList}
                    selectName={`cargoDetails.0.totalVolume.unit`}
                    control={control}
                    name={`cargoDetails.${i}.totalVolume.value`}
                     rules={{
                              required: "Required",
                              validate: (value) => {
                                let isValue = validateGreaterThanZero(value);
                                const totalVolume = getValues(
                                  `cargoDetails.0.totalVolume.unit`
                                );
                                if (typeof isValue === "string") {
                                  return isValue;
                                } else if (mode !== "fcl") {
                                  return;
                                  let maxValue =
                                    lclWeightForPort["totalvolume"][
                                      totalVolume.toLowerCase()
                                    ];

                                  if (value > maxValue) {
                                    // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                    return `value can't be greater than ${
                                      maxValue + " " + totalVolume
                                    } `;
                                  }
                                }
                              },
                            }}
                  />
                )}
              </div>
            </div>
          </div>
        ))}

        {/* Add Package Line Button */}
        {(cartingStore?.disable === false || cartingStore?.update === true) && (
          <button
            type="button"
            onClick={() => {
              let newCargo = new Cargo();
              newCargo.totalVolume.unit = totalVolume;
              newCargo.totalWeight.unit = totalWeight;
              newCargo.weight.unit = weight;
              appendCargo({ ...newCargo });
            }}
            className="w-full py-3.5 px-4 rounded-xl border-[1.6px] border-dashed border-[#C7D0D8] bg-white text-[#4BA7DD] font-semibold text-sm flex items-center justify-center gap-1.5 hover:bg-[#EBF3FF] active:scale-[0.99] transition-all cursor-pointer"
          >
            <span>+ Add package line</span>
          </button>
        )}
      </div>
<div className="w-full">
        <LabeledTextField
          labelStyle={{
            fontSize: "12px",
            color: process.env.REACT_APP_ENTERPRISE_COLOUR || "#64748B",
            fontWeight: "bold",
          }}
          label="Net Weight(Kgs) *"
          control={control}
          name="netWeight"
          type="number"
          size="small"
          fullWidth
          rules={{ required: "Required" }}
          disabled={cartingStore?.disable && !cartingStore?.update}
        />
      </div>
      {/* Summary Cards Row */}
      <div className="grid grid-cols-3 gap-2.5 w-full mt-1">
        <div className="bg-[#FEF6EE] border border-[#FFEDD5] rounded-xl p-3 flex flex-col justify-center gap-1">
          <span className="text-[10px] font-bold text-[#9A3412] uppercase tracking-wider">TOTAL QTY</span>
          <span className="text-base font-extrabold text-[#7C2D12]">
            {isNaN(total.totNumPackages) ? 0 : total.totNumPackages}
          </span>
        </div>
        <div className="bg-[#FEF6EE] border border-[#FFEDD5] rounded-xl p-3 flex flex-col justify-center gap-1">
          <span className="text-[10px] font-bold text-[#9A3412] uppercase tracking-wider">TOTAL WEIGHT</span>
          <span className="text-base font-extrabold text-[#7C2D12]">
            {isNaN(total.totTotalWeight) ? 0 : total.totTotalWeight} Kgs
          </span>
        </div>
        <div className="bg-[#FEF6EE] border border-[#FFEDD5] rounded-xl p-3 flex flex-col justify-center gap-1">
          <span className="text-[10px] font-bold text-[#9A3412] uppercase tracking-wider">
            {mode === "air" ? "CHARGEABLE WT" : "TOTAL VOLUME"}
          </span>
          <span className="text-base font-extrabold text-[#7C2D12]">
            {mode === "air"
              ? `${isNaN(total.totChargeableWeight) ? 0 : total.totChargeableWeight} Kgs`
              : `${isNaN(total.totTotalVolume) ? 0 : total.totTotalVolume} CBM`}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function CartingorderEdit(props) {
  const isMobile = useMobile();
  const { data, onClose } = props || {};
  const LabelStyle =
    "flex items-center justify-center border-l-[0.5px] border-l-solid border-l-[#D4D4D4] font-bold text-sm min-w-[24px] h-full";
  const DimensionLabelStyle = {
    height: "25px",
    width: "80px",
    padding: 0,
    fontSize: "13px",
  };
  useSnapshot(configStore);
  useSnapshot(cartingStore);
  useSnapshot(AgmodalStore);
  useSnapshot(EntityV2Store)
  useSnapshot(aguserStore);
  const [valid, setValid] = useState(true);
  const [selectedType, setType] = useState("LCL");
  const [mode, setMode] = useState("lcl");
  const [isDimension, setIsDimension] = useState(false);
  const ref = useRef(null);
  const [update, setUpdate] = useState(false);
  const [agActiveList, setAgActiveList] = useState([])
  const [inputValue, setInputValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [options, setOptions] = useState([]);
  const [leoDate,setLeoDate] = useState(cartingStore.current.LeoDateTime)
  const [total, setTotal] = useState({
    totNumPackages: 0,
    totTotalWeight: 0,
    totTotalVolume: 0,
    totChargeableWeight: 0,
  });
    const [ currentTradeType ,  setcurrentTradeType] = useState("")
  const [entityDataobj , setentityDataobj] = useState({})
  const cargoForm = useForm({
    defaultValues: {
      mode: "LCL",
      invoiceDetails: [
        {
          invoiceNo: "",
          HSCode: "",
          marksNos: "",
          commodityType: "",
        },
      ],
      cargoDetails: [new Cargo()],
      cargoDimensionUnit: "Cms",
      hazardous: false,
      nonStackable:false,
      nomination:false
    },
  });
  const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
  } = cargoForm;
  const onSubmit = (data) => {
    let kz = Object.keys(data)
    for (let i = 0; i < kz.length; i++) {
      console.log(kz[i],data[kz[i]])
      if(typeof data[kz[i]] === "string"){
        data[kz[i]] = data[kz[i]].trim()
        setValue(kz[i], data[kz[i]])
      }
    }
    let k1 = Object.keys(cartingStore.requiredlist);
    let v = true
    let l = ["portOfReceipt","portOfLoading","portOfDischarge","finalPlaceOfDelivery"]
    for (let i = 0; i < k1.length; i++) {
        if((k1[i]!='netWeight' && k1[i]!="reworkingPort" && l.indexOf(k1[i])==-1 && (data[k1[i]]==undefined || data[k1[i]].length==0)) ||
         (k1[i]=='netWeight' && (data[k1[i]]==undefined || Number(data[k1[i]])<1)) ||
        (l.indexOf(k1[i])!=-1 && !getvaild(k1[i],false)) || 
        (k1[i]=="reworkingPort" && !getvaild(k1[i],false,true))){
          v = false
          setValid(false)
      
      if(!v){
        switch(true){
          case k1[i]=='netWeight':
            configStore.setModalMessage(`Please Enter Net Weight minimum 1`);
            break;
          default:
            configStore.setModalMessage(`Please check the fields`);
        }
        i = k1.length+1
      }
      }
    }
    if(v){
      // loader.show();
      let k = Object.keys(cartingStore.list);
      for (let i = 0; i < k.length; i++) {
        if(data[k[i]]!=undefined){
          cartingStore.current[k[i]] = data[k[i]];
        }
      }
      cartingStore.current.LeoDateTime = leoDate
      cartingStore.current["totalWeight"] = total.totTotalWeight
      cartingStore.current["totalNumPackages"] = total.totNumPackages
      cartingStore.current["totalVolume"] = total.totTotalVolume
      cartingStore.current.entityId = data.entityId || cartingStore.current.entityId || "";
      console.log(" the carting sheet current is ",cartingStore.current)
      // return;
      if(cartingStore.update==true){
        const callback = (d) => {
          loader.hide();
          if(d.message==undefined){
            cartingStore.current = JSON.parse(JSON.stringify(d));
            configStore.setModalMessage(`Updated successfully. Carting Sheet Ref No#:` + d["_id"],[],false);
            AgmodalStore.pageVisible = false;
            AgmodalStore.apiCall = true;
          }else{
            configStore.setModalMessage(d.message,[],false);
          }
        };
        CartingOrderApi.UpdateCartingorder(cartingStore.current, callback);
      }else{
        const callback = (d) => {
          console.log(d);
          loader.hide();
          cartingStore.current = JSON.parse(JSON.stringify(d));
          configStore.setModalMessage(`Carting Sheet Ref No#:` + d["_id"],[],false);
          AgmodalStore.pageVisible = false;
          AgmodalStore.apiCall = true;
          if(isMobile){
            onClose?.();
            cartingStore.update=false
            cartingStore.setValidation()
            cartingStore.current = JSON.parse(JSON.stringify(cartingStore.new));
          }
        };
        CartingOrderApi.CreateCartingorder(cartingStore.current, callback);
      }
    }
  };



  const dimensionsUnit = watch("cargoDimensionUnit");
  const entityId = getValues('entityId')  
  const weight = getValues(`cargoDetails.0.weight.unit`);
  let cargodetailsFromForm = watch(`cargoDetails`);
  const totalWeight = getValues(`cargoDetails.0.totalWeight.unit`);
  const totalVolume = getValues(`cargoDetails.0.totalVolume.unit`);
    const POR = getValues('portOfReceipt') 
      const FPOD = getValues('finalPlaceOfDelivery') 
  const rsi =
    watch("remarks_special_instrctions") == undefined
      ? ""
      : watch("remarks_special_instrctions");

  const {
    fields: invoiceDetails,
    append: appendInvoice,
    remove: removeInvoice,
  } = useFieldArray({
    control: control,
    name: `invoiceDetails`,
  });

  const {
    fields: cargoDetails,
    append: appendCargo,
    remove: removeCargo,
  } = useFieldArray({
    control: control,
    name: `cargoDetails`,
  });
  const inovicede = watch("invoiceDetails");
  let hazardous = watch("hazardous");
  let reefer = watch("reefer");
  let overHeight = watch("overHeight");
  let overlength = watch("overlength");
  let topLoading = watch("topLoading");
  let fumigation = watch("fumigation");
  let headLoad = watch("headLoad");
  let doorLoad = watch("doorLoad");
  let nonStackable = watch("nonStackable")
  let nomination = watch("nomination")
  let bankInvolved = watch("bankInvolved")
  let consigneeName = watch("consigneeName")
  let portlist = [
    {
      label:"ICD Tughlakabad, India (INTKD)",
      value:"ICD Tughlakabad, India (INTKD)"
    },
    {
      label:"Ahmedabad, India (INAMD)",
      value:"Ahmedabad, India (INAMD)"
    },
    {
      label:"Bangalore, India (INBLR)",
      value:"Bangalore, India (INBLR)"
    },
    {
      label:"Hyderabad, India (INHYD)",
      value:"Hyderabad, India (INHYD)"
    },
    {
      label:"Nhava Sheva, India (INNSA)",
      value:"Nhava Sheva, India (INNSA)"
    },
    {
      label:"Chennai (ex Madras), India (INMAA)",
      value:"Chennai (ex Madras), India (INMAA)"
    }
  ]
  useEffect(()=>{
    if(bankInvolved && consigneeName!="TO THE ORDER OF"){
      setValue("consigneeName",'TO THE ORDER OF')
    }
    if(!bankInvolved && consigneeName=="TO THE ORDER OF"){
      setValue("consigneeName",'')
    }
  },[bankInvolved,consigneeName])

  const formValues = watch();
  const check = async () => {
    if (!valid) {
      await trigger();
    }
  };
  
 
  const handleSelectChange = (value) => {
    setSelectedValue(value);
    setValue("CFSLocation",value)
  };
  const handleInputChange = (value) => {
    setInputValue(value);
    setValue("CFSLocation",value)
  };
  useEffect(()=>{
    const callback = (data) =>{
      let d = data.filter(item => item.trim() !== "");
      if(JSON.stringify(options)!=JSON.stringify(d)){
        setOptions(d)
      }
    }
    CartingOrderApi.getCfslocations(callback)
  },[])
  useEffect(() => {
    check();
    console.log(formValues);
  }, [JSON.stringify(formValues)]);

  useEffect(() => {
    if (enquiryStore && enquiryStore.current) {
      enquiryStore.current.shipmentType = selectedType;
    }
  }, [selectedType]);

  useEffect(() => {
    console.log(" the entity cuslit is ",EntityV2Store.Cuslist)
    if (!EntityV2Store.Cuslist || EntityV2Store.Cuslist.length === 0) {
      EntityApi.getList();
    }
  }, []);

  useEffect(() => {
    if (data !== undefined) {
      applyShippingBillData(data);
    }
  }, [data]);


  useEffect(() => {
    if (
      update == false &&
      cartingStore.current._id != undefined &&
      cartingStore.current._id.length > 0
    ) {
      setUpdate(false);
      loader.show();
      let k = Object.keys(cartingStore.list);
      setType(cartingStore.current['mode']);
      setMode(cartingStore.current['mode'].toLowerCase());
      for (let i = 0; i < k.length; i++) {
        setValue(k[i], cartingStore.current[k[i]]);
      }
      if(cartingStore.current["CFSLocation"]!=undefined && cartingStore.current["CFSLocation"]!=selectedValue){
        setSelectedValue(cartingStore.current["CFSLocation"])
      }
      loader.hide();
      setUpdate(true);
    } else {
      setUpdate(true);
    }
    if(cartingStore.current.shippingBillchecklist_filename_list==undefined){
      cartingStore.current.shippingBillchecklist_filename_list = []
    }
    if(cartingStore.current.fetchshippingBillchecklist==undefined){
      cartingStore.current.fetchshippingBillchecklist = ""
    }
  }, [JSON.parse(JSON.stringify(cartingStore.current))]);

  const changeShipmentTypes = (type) => {
    if(!cartingStore.disable){
      setValue('mode',type)
      setType(type);
      setMode(type.toLowerCase());
      setValue("cargoDetails", [new Cargo()]);
      handleNominationChange()
    }
  };

  const calculateWeightAndVolume = () => {
    if (
      JSON.stringify({
        totNumPackages: 0,
        totTotalWeight: 0,
        totTotalVolume: 0,
        totChargeableWeight: 0,
      }) != JSON.stringify(total)
    ) {
      setTotal({
        totNumPackages: 0,
        totTotalWeight: 0,
        totTotalVolume: 0,
        totChargeableWeight: 0,
      });
    }
    if (getValues(`cargoDetails`) != undefined) {
      let mode = getValues("mode");
      let scope = getValues("scope");
      let volumeInDimensions = getValues("volumeInDimensions");
      let isLclDimension = volumeInDimensions && mode.toLowerCase().includes("lcl") && scope.includes("Door")
      let totals = Utils.calcCargoDetails(
        getValues(`cargoDetails`),
        isDimension || isLclDimension,
        dimensionsUnit,
        mode,
        cargodetailsFromForm[0]
      );
      setTotal({ ...totals });
      setValue("grandTotalWeight",totals.totTotalWeight)
            setValue("grandTotalVolume",totals.totTotalVolume)
            setValue("grandChargeable",totals.totChargeableWeight)
    }
  };

  useEffect(() => {
    calculateWeightAndVolume();
  }, [JSON.stringify(cargodetailsFromForm)]);
  useEffect(() => {
    setValue(`cargoDetails.0.totalWeight.unit`, weight);
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.weight.unit`, weight);
    }
    calculateWeightAndVolume();
  }, [weight]);

  useEffect(() => {
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.totalWeight.unit`, totalWeight);
    }
    calculateWeightAndVolume();
  }, [totalWeight]);

  useEffect(() => {
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.totalVolume.unit`, totalVolume);
    }
    calculateWeightAndVolume();
  }, [totalVolume]);

  useEffect(() => {
    calculateWeightAndVolume();
  }, [dimensionsUnit]);

  const validateGreaterThanZero = (value) => {
    return parseFloat(value) > 0 || "Required";
  };
  useEffect(() => {
    calculateWeightAndVolume();
  }, [isDimension]);
    const filecat = '' + Date.now()
  const delFile = (a,ind)=>{
        let l = []
        for (let i = 0; i < a.length; i++) {
            if(i!=ind){
                l.push(a[i])
            }
        }
        return l
    }
const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank" className="truncate inline-block max-w-full align-bottom" title={fileName}>{fileName}</a>
            )
        } else return <></>
    }

  const getvaild = (name, ch=true, rw=false) =>{
    if(!valid || !ch){
      if(!rw && (formValues[name]==undefined || formValues[name].length==0)){
        return false
      }else if(rw && (formValues[name]==undefined || formValues[name].length==0)){
          return true
      }else{
        return cartingStore.validation[name]
      }
    }else{
      return true
    }
  }

  useEffect(()=>{
      console.log(" the ag active list is ",agActiveList)
  },[agActiveList])

  useEffect(()=>{
      const agactiveuserlist = () =>{
        let l = []
        for (let i = 0; i < aguserStore.list.length; i++) {
          let e = aguserStore.list[i]
          if(e['status']=="ACTIVE" && e['email'].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)!=-1){
            l.push(
              {
                label:aguserStore.getName4email(e['email']),
                value:aguserStore.getName4email(e['email'])
              }
            )
          }
        }
        if(JSON.stringify(agActiveList)!=JSON.stringify(l)){
          setAgActiveList(l)
        }
      }
      agactiveuserlist()
    },[aguserStore.list])
    useEffect(() => {
      AguserApi.getList();
    }, []);

  // useEffect(() => {
  //   if(cartingStore.current.nomination !== nomination ){
  //   cartingStore.current.salesperson = ""
  //   cartingStore.current.customerService = ""
  //   let e = ""
  //   setValue('salesperson', e)
  //   setValue('customerService', e)
  //   }
  // }, [nomination])

  const handleNominationChange = (newNomination) => {
    cartingStore.current.salesperson = "";
    cartingStore.current.customerService = "";
    const e = "";
    setValue("salesperson", e);
    setValue("customerService", e);
  };

    useEffect(() => {
        getEntityData()
        console.log("cartingStore.current",cartingStore.current,entityId);
      }, [entityId , nomination  , mode , selectedType , currentTradeType])

      const getEntityData = async ()=>{  
        console.log("cartingStore.current",cartingStore.current,entityId);
        if (!entityId) {
          if (entityDataobj?.entityId?.length > 0) {
            setentityDataobj({})
            cartingStore.current.salesperson = "";
            setValue('salesperson', "")
            cartingStore.current.customerService = "";
            setValue('customerService', "")
          }
          return ""
        }
        let entity 
        if (!entityDataobj?.entityId?.length > 0 && entityId) {
          entity = await EntityV2Api.viewEntity(entityId)
          setentityDataobj(entity)
        } else {
          entity = entityDataobj
        }
        console.warn("FOUND ENTITY = ", entity);
        if (entity && entity?.entityId?.length > 0) {
          //  let tradeType = Utils.getTradeType({
          //     rec: cartingStore.current,
          //     shipmentType: cartingStore.current['mode'],
          //     entityCountry: entity.entityCountry
          //   }) 
          let por = POR?.toLowerCase()
          let fpod = FPOD?.toLowerCase()
            let tradeType = Utils.getTrade(entity.entityCountry.toLowerCase() , por , fpod)
            if(cartingStore.current.tradeType == undefined || cartingStore.current.tradeType!=tradeType){
              cartingStore.current.tradeType = tradeType
            }
            if(tradeType === ''){
               tradeType= "Export"
            }
             setcurrentTradeType(tradeType)
          if(cartingStore.current.salesperson==undefined || (cartingStore.current.salesperson!=undefined && cartingStore.current.salesperson.length == 0 )){
             let k = []
            let rmEmailList = entity?.customer?.crossBorder?.relationshipManagers;
              //  let por = quoteDataRec.portOfReceipt.toLowerCase()
              //     let fpod = quoteDataRec.finalPlaceOfDelivery.toLowerCase()
              //     if (shipmentType === 'AIR') {
              //         por = quoteDataRec.originAirport.toLowerCase()
              //         fpod = quoteDataRec.destinationAirport.toLowerCase()
              //     }getTrade
              //   if(por.indexOf(country) >= 0) tradetype = "import"
              //   else if (fpod.indexOf(country) >= 0) tradetype = "export"  
           
                  let rmemails = Utils.getRelationShipMangerForType(rmEmailList , mode  , tradeType  , nomination );
                  if(rmemails && rmemails?.length>0 ){
                    rmemails.map((x,y) => {
                      k.push(aguserStore.getdetails(x.email))
                    })
                    let e = aguserStore.getName4email(rmemails[0].email)
                    cartingStore.current.salesperson =aguserStore.getName4email(rmemails[0].email);
                    setValue('salesperson', e)
                  }
                  else {
                    cartingStore.current.salesperson = "";
                    setValue('salesperson', "")
                  }
            // if(email){
            //   let e = aguserStore.getName4email(email)
            //   cartingStore.current.salesperson = e;
            //   setValue('salesperson',e)
            // }else {
            //   cartingStore.current.salesperson = "";
            //   setValue('salesperson',"")
            // }
          }
          if(cartingStore.current.customerService==undefined || (cartingStore.current.customerService!=undefined && cartingStore.current.customerService.length == 0)){
      let csEmailList = entity?.customer?.crossBorder?.customerService;
      let k=[]
      let csemails = Utils.getCustomerServiceForType(csEmailList , mode , tradeType , nomination  );
            if (csemails && csemails?.length > 0  ) {
              csemails.map((x, y) => {
                k.push(aguserStore.getdetails(x.email))
              })
              let e = aguserStore.getName4email(csemails[0]?.email)
              cartingStore.current.customerService = e;
              setValue('customerService', e)
                }else {
              cartingStore.current.customerService = "";
                  setValue('customerService',"")
            }
                //     if (email){
                //       let e = aguserStore.getName4email(email)
                //   cartingStore.current.customerService = e;
                //   setValue('customerService',e)
                //     }else {
                //   cartingStore.current.customerService = "";
                //   setValue('customerService',"")
                // }
          }
          
        }
      }

  const checkTradetypefn = async () => {
    if (!entityId || !POR || !FPOD || !entityDataobj?.entityCountry || !currentTradeType) {
      return ""
    }
    let tradetype = ""
    let country = entityDataobj?.entityCountry?.toLowerCase()
    let por = POR.toLowerCase()
    let fpod = FPOD.toLowerCase()
    // if (shipmentType.toLowerCase() === 'air') {
    //   por = quoteDataRec.originAirport.toLowerCase()
    //   fpod = quoteDataRec.destinationAirport.toLowerCase()
    // }
    tradetype = Utils.getTrade(country, por, fpod)
    if (tradetype !== currentTradeType) {
      cartingStore.current.salesperson = ""
      cartingStore.current.customerService = ""
      let e = ""
      setValue('salesperson', e)
      setValue('customerService', e)
      setcurrentTradeType(tradetype)
    }

  }

  useEffect(() => {
    checkTradetypefn()
  }, [POR, FPOD]) 

      const generateId = (id,i)=> {
        if(id==undefined){
            let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000)
            cargodetailsFromForm[i].id = a
            return a
        }else{
            return id
        }
    }

      const generateInvoiceId = (id, i) => {
        if (id == undefined) {
          let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000);
          if (inovicede && inovicede[i]) {
            inovicede[i].id = a;
          }
          return a;
        } else {
          return id;
        }
      }

      const chkDropDnValid = ()=> {
    let valid = true
    if(!entityId || !formValues["salesperson"]  || !formValues["customerService"]){
      valid = false
    }
    return valid 
  }

  const applyShippingBillData = (dataParam) => {
    if (!dataParam) return;

    const updatePortField = (fieldName, apiKey) => {
      const rawVal = dataParam[apiKey];
      if (rawVal != null && String(rawVal).trim().length > 0) {
        const cleanVal = String(rawVal).trim();

        // 1. Set immediate value in form and store
        setValue(fieldName, cleanVal, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        if (cartingStore.current) {
          cartingStore.current[fieldName] = cleanVal;
        }
        trigger(fieldName);

        // 2. Fetch mapped UNLOC description asynchronously
        const queryTerm = cleanVal.substring(0, 5);
        Api.getMapUnloc({ descriptions: [queryTerm, "Carted"] }, (d) => {
          if (d && d.length > 0) {
            setValue(fieldName, d[0], { shouldValidate: true, shouldDirty: true, shouldTouch: true });
            if (cartingStore.current) {
              cartingStore.current[fieldName] = d[0];
            }
            trigger(fieldName);
          } else {
            Api.getMapUnloc({ descriptions: [queryTerm, selectedType || "LCL"] }, (d2) => {
              if (d2 && d2.length > 0) {
                setValue(fieldName, d2[0], { shouldValidate: true, shouldDirty: true, shouldTouch: true });
                if (cartingStore.current) {
                  cartingStore.current[fieldName] = d2[0];
                }
                trigger(fieldName);
              }
            });
          }
        });
      }
    };

    updatePortField('portOfLoading', 'portOfLoading');
    updatePortField('portOfDischarge', 'portOfDischarge');
    updatePortField('finalPlaceOfDelivery', 'finalPlaceOfDelivery');

    const fields = [
      "shipperName",
      "shippergst",
      "shippingBillNo",
      "shippingBillDate",
      "address",
      "consigneeName",
      "consigneeAddress",
      "CHANumber",
      "CHAName",
      "IECCode"
    ];

    fields.forEach((key) => {
      const value = dataParam[key];
      if (value != null && String(value).trim().length > 0) {
        const cleanVal = String(value).trim();
        setValue(key, cleanVal, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        if (cartingStore.current) cartingStore.current[key] = cleanVal;
        trigger(key);
      }
    });

    if (dataParam.invoiceDetails != null && Array.isArray(dataParam.invoiceDetails) && dataParam.invoiceDetails.length > 0) {
      dataParam.invoiceDetails.forEach((invoice, index) => {
        ["invoiceNo", "HSCode", "commodityType"].forEach((key) => {
          const value = invoice[key];
          if (value != null && String(value).trim()) {
            const cleanVal = String(value).trim();
            setValue(`invoiceDetails.${index}.${key}`, cleanVal, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
            trigger(`invoiceDetails.${index}.${key}`);
          }
        });
      });
    }

    if (cartingStore.current?.shippingBillchecklist_filename_list && cartingStore.current.shippingBillchecklist_filename_list.length > 0) {
      cartingStore.current.fetchshippingBillchecklist = cartingStore.current.shippingBillchecklist_filename_list[0];
    }
  };

  const fetchshippingBillchecklist = () => {
    loader.show();
    Api.fetchshppingbillchecklist({ url: process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + cartingStore.current.shippingBillchecklist_filename_list[0] }, (result) => {
      if (result['success']) {
        applyShippingBillData(result['data']);
        loader.hide();
      } else {
        configStore.setModalMessage(result['message']);
        loader.hide();
      }
    });
  };

  const section1Completed = Boolean(
    watch("shipperName")?.trim() &&
    watch("address")?.trim() &&
    watch("shippingBillNo") &&
    watch("shippingBillDate") &&
    !errors.shipperName &&
    !errors.address &&
    !errors.shippingBillNo &&
    !errors.shippingBillDate
  );

  const section2Completed = Boolean(
    inovicede?.some(inv => inv.invoiceNo?.trim() || inv.HSCode?.trim()) &&
    !errors.invoiceDetails
  );

  const section3Completed = Boolean(
    watch("consigneeName")?.trim() &&
    watch("consigneeAddress")?.trim() &&
    watch("CHAName")?.trim() &&
    watch("CHANumber")?.trim() &&
    !errors.consigneeName &&
    !errors.consigneeAddress &&
    !errors.CHAName &&
    !errors.CHANumber
  );

  const section4Completed = Boolean(
    watch("portOfReceipt") &&
    watch("portOfLoading") &&
    watch("portOfDischarge") &&
    watch("finalPlaceOfDelivery") &&
    !errors.portOfReceipt &&
    !errors.portOfLoading &&
    !errors.portOfDischarge &&
    !errors.finalPlaceOfDelivery
  );

  const section5Completed = Boolean(
    watch("netWeight") > 0 &&
    !errors.netWeight &&
    !errors.cargoDetails &&
    !errors.grandTotalWeight &&
    !errors.grandTotalVolume
  );

  const section6Completed = Boolean(watch("remarks_special_instrctions")?.trim());

  const section7Completed = Boolean(
    cartingStore.current?.commercialInvoice_filename_list?.length > 0 ||
    cartingStore.current?.shippingBill_filename_list?.length > 0
  );

  const completedSectionsCount = [
    section1Completed,
    section2Completed,
    section3Completed,
    section4Completed,
    section5Completed,
    section6Completed,
    section7Completed
  ].filter(Boolean).length;

  return (
    <>
      {isMobile && (
        <div className="flex flex-row w-full justify-between items-center">
        <h1 className="text-blue-dark font-extrabold text-2xl">Carting Sheet</h1>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full border-0 flex items-center justify-center text-gray-500 hover:bg-gray-100 active:scale-95 transition-all shrink-0 cursor-pointer bg-white"
            aria-label="Close and back to upload"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        </div>
      )}
      {((EntityV2Store.Cuslist != undefined && EntityV2Store.Cuslist.length > 0) || isMobile || update) && (
        <>
          {!isMobile && (
            <div class="mb-2 mt-2">
              <Headspan
                color="#555555"
                fontSize="20px"
                fontWeight="700"
                data={
                  cartingStore.current._id != undefined &&
                  cartingStore.current._id.length > 0
                    ? "Carting Sheet Ref. No# "
                    : "Carting Sheet"
                }
              />
              {cartingStore.current._id != undefined &&
              cartingStore.current._id.length > 0 ? (
                <Headspan
                  color={process.env.REACT_APP_ENTERPRISE_COLOUR}
                  fontSize="20px"
                  fontWeight="700"
                  data={cartingStore.current._id}
                />
              ) : (
                ""
              )}
            </div>
          )}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={1}
                title="Shipping Details"
                subtitle={`${watch("shipperName") || "Shipper"} · SB ${watch("shippingBillNo") || "—"}`}
                isCompleted={section1Completed}
                isOptional={false}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Shipping Details</p>
                </div>
                <ShippingDetailsSwitches
                  control={control}
                  register={register}
                  nomination={nomination}
                  bankInvolved={bankInvolved}
                  handleNominationChange={handleNominationChange}
                  disable={cartingStore.disable}
                  isMobile={false}
                />
              </div>
            )}
            <div className="columns is-vcentered is-multiline qoutecard">
              {[
                {
                  lable: "Shipper Name *",
                  type: "string",
                  name: "shipperName",
                  rules:{ required: "Required" }
                },
                {
                  lable: "Address *",
                  type: "string",
                  name: "address",
                  rules:{ required: "Required" }
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "IEC Code",
                  type: "string",
                  name: "IECCode",
                  rules:{}
                },
                {
                  lable: "Shipping Bill No *",
                  type: "number",
                  name: "shippingBillNo",
                  rules:{ required: "Required",minLength: {
      value: 7,
      message: "Must be exactly 7 characters"
    },
    maxLength: {
      value: 7,
      message: "Must be exactly 7 characters"
    }  }
                },
                {
                  lable: "Shipping Bill Date *",
                  type: "date",
                  name: "shippingBillDate",
                  rules:{ required: "Required" }
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "Leo Date & Time",
                  type: "datetime-local",
                  name: "LeoDateTime",
                  rules:{}
                },
              ].map((e) => {
                return (
                                    <div className="column is-3">

                 <OneDateTime1 name={e.name} label={e.lable} record={cartingStore.current} isDisabled={cartingStore.disable && !cartingStore.update} callback={(value)=>{
                      setLeoDate(value)
                 }}/>
                 </div>
                );
              })}
              </div>
              {isMobile && (
                <ShippingDetailsSwitches
                  control={control}
                  register={register}
                  nomination={nomination}
                  bankInvolved={bankInvolved}
                  handleNominationChange={handleNominationChange}
                  disable={cartingStore.disable}
                  isMobile={true}
                />
              )}
              {/* <div className="columns is-vcentered is-multiline qoutecard">
              {inovicede.map((e, i) => {
                return (
                  <>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.invoiceNo`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Invoice No"
                        control={control}
                        name={`invoiceDetails.${i}.invoiceNo`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.marksNos`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Marks & Nos"
                        control={control}
                        name={`invoiceDetails.${i}.marksNos`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.HSCode`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="HS Code"
                        control={control}
                        name={`invoiceDetails.${i}.HSCode`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-2">
                      <AgSelectCA
                        label="Commodity Type"
                        name="commodityType"
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        value={e.commodityType}
                        dataList={commodityList}
                      />
                    </div>
                    <div className="column is-1">
                      <p style={{ paddingTop: "20%", textAlign: "center" }}>
                        {inovicede.length == i + 1 ? (
                          <button
                            className="button is-success is-inverted"
                            onClick={() => {
                              appendInvoice({
                                ...{
                                  invoiceNo: "",
                                  HSCode: "",
                                  marksNos: "",
                                  commodityType: "",
                                },
                              });
                            }}
                          >
                            <span className="icon is-small">
                              <i className="fas fa-plus"></i>
                            </span>
                          </button>
                        ) : (
                          <button
                            className="button is-danger is-inverted"
                            onClick={() => {
                              removeInvoice(i);
                            }}
                          >
                            <span className="icon">
                              <i className="fas fa-trash"></i>
                            </span>
                          </button>
                        )}
                      </p>
                    </div>
                  </>
                );
              })}
            </div> */}
          </div>
          {!isMobile && <hr />}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={2}
                title="Invoice Details"
                subtitle="Invoice No, HS Code, Commodity"
                isCompleted={section2Completed}
                isOptional={true}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Invoice Details</p>
                </div>
              </div>
            )}
              <div className="columns is-vcentered is-multiline qoutecard">
              {inovicede?.map((e, i) => {
                return (
                  <div key={generateInvoiceId(e.id, i)} className={`w-full flex ${isMobile?"flex-col":"flex-row"}`}>
                    <div className="column is-3">
                      <LabeledTextField
                        key={generateInvoiceId(e.id, i)}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.invoiceNo`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Invoice No"
                        control={control}
                        name={`invoiceDetails.${i}.invoiceNo`}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={generateInvoiceId(e.id, i)}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.marksNos`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Marks & Nos"
                        control={control}
                        name={`invoiceDetails.${i}.marksNos`}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={generateInvoiceId(e.id, i)}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.HSCode`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="HS Code"
                        control={control}
                        name={`invoiceDetails.${i}.HSCode`}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <div className="column is-2">
                      <LabeledTextField
                        key={generateInvoiceId(e.id, i)}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Commodity Type"
                        control={control}
                        name={`invoiceDetails.${i}.commodityType`}
                        size="small"
                        fullWidth
                      />
                      {/* <AgSelectCA
                        label="Commodity Type"
                        name="commodityType"
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        value={e.commodityType}
                        dataList={commodityList}
                      /> */}
                    </div>
                     {<div className="column is-1">
                      {(isMobile && inovicede.length > 1) ? (
                         
                          <div className="flex justify-end pt-1">
                            <button
                              type="button"
                              className="button is-danger is-inverted"
                              onClick={() => {
                                removeInvoice(i);
                              }}
                            >
                              <span className="icon">
                                <i className="fas fa-trash"></i>
                              </span>
                            </button>
                          </div>
                      ) : ( !isMobile &&
                        <p style={{ paddingTop: "20%", textAlign: "center" }}>
                          {inovicede.length == i + 1 ? (
                            <button
                              className="button is-success is-inverted"
                              onClick={() => {
                                appendInvoice({
                                  ...{
                                    invoiceNo: "",
                                    HSCode: "",
                                    marksNos: "",
                                    commodityType: "",
                                  },
                                });
                              }}
                            >
                              <span className="icon is-small">
                                <i className="fas fa-plus"></i>
                              </span>
                            </button>
                          ) : (
                            <button
                              className="button is-danger is-inverted"
                              onClick={() => {
                                removeInvoice(i);
                              }}
                            >
                              <span className="icon">
                                <i className="fas fa-trash"></i>
                              </span>
                            </button>
                          )}
                        </p>
                      )
                      }
                    </div>}
                  </div>
                );
              })}
              
            </div>
            {isMobile && (
                <button
                  type="button"
                  onClick={() => {
                    appendInvoice({
                      invoiceNo: "",
                      HSCode: "",
                      marksNos: "",
                      commodityType: "",
                    });
                  }}
                  className="w-full py-3.5 px-4 rounded-xl border-[1.6px] border-dashed border-[#C7D0D8] bg-white text-[#4BA7DD] font-semibold text-sm flex items-center justify-center gap-1.5 hover:bg-[#EBF3FF] active:scale-[0.99] transition-all cursor-pointer"
                >
                  <span>+ Add another invoice line</span>
                </button>
              )}
          </div>
          {!isMobile && <hr />}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={3}
                title="Parties Involved"
                subtitle={`${watch("consigneeName") || "Consignee"} · CHA: ${watch("CHAName") || "—"}`}
                isCompleted={section3Completed}
                isOptional={false}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Parties Involved</p>
                </div>
              </div>
            )}
            <div className="columns is-vcentered is-multiline qoutecard">
              {[
                {
                  lable: "Consignee Name *",
                  type: "string",
                  name: "consigneeName",
                },
                {
                  lable: "Consignee Address *",
                  type: "string",
                  name: "consigneeAddress",
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "CHA Name *",
                  type: "string",
                  name: "CHAName",
                },
                {
                  lable: "CHA Number *",
                  type: "string",
                  name: "CHANumber",
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              <div className="column is-3">
                <AgCustlistCH
                  label="Customer Name"
                  name="entityId"
                  dataList={EntityV2Store.Cuslist}
                  callback={(e1) => {
                    cartingStore.current.entityId = e1;
                    cartingStore.current.salesperson = "";
                    cartingStore.current.customerService = "";
                    setValue(`entityId`, e1, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
                  }}                
                  value={formValues["entityId"] || cartingStore.current?.entityId}
                  isDisabled={{disabled:cartingStore.disable}}    
                  // isValid={getvaild('entityId')}  
                  // borderHighlight={true}   
                  // rules={{ required: "Required" }}
                  width="100%"
                  control={control}   
                 
                />
              </div>
              <div className="column is-3">
                <AgSelectLatestCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Relationship Manager"
                  name="salesperson"
                  dataList={agActiveList}
                  callback={(e1) => {
                    console.log(" the slected salesperson is ",e1)
                    cartingStore.current.salesperson = e1
                    setValue(`salesperson`, e1);
                  }}
                  value={formValues["salesperson"]}
                  // isValid={getvaild('salesperson')} 
                  // validationMsg="Please select salesperson" 
                  //  rules={{ required: "Required" }}
                   width= "100%"      
                   control={control}     
                   
                />
              </div>
              <div className="column is-3">
                <AgSelectLatestCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Customer Service"
                  name="customerService"
                  dataList={agActiveList}
                  callback={(e1) => {
                    cartingStore.current.customerService = e1
                    setValue(`customerService`, e1);
                  }}
                  value={formValues["customerService"]}
                  // isValid={getvaild('customerService')} 
                  // validationMsg="Please select customerservice" 
                  //  rules={{ required: "Required" }}
                  width="100%"
                  control={control}   
              
                />
              </div>
            </div>
          </div>
          {!isMobile && <hr />}
          {/* <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Route Details</p>
              </div>
              <div className="flex flex-row gap-[10px]">
                <ActiveTabCH
                  callback={changeShipmentTypes}
                  selectedType={selectedType}
                />
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-3">
                <AgUnlocCH
                  shipmentType={selectedType}
                  label="Origin"
                  name="origin"
                  callback={(e1) => {
                    setValue(`origin`, e1);
                  }}
                  value={formValues["origin"]}
                />
              </div>
              <div className="column is-3">
                <AgUnlocCH
                  shipmentType={selectedType}
                  label="Destination"
                  name="destination"
                  callback={(e1) => {
                    setValue(`destination`, e1);
                  }}
                  value={formValues["destination"]}
                />
              </div>
            </div>
          </div>
          <hr /> */}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={4}
                title="Port Details"
                subtitle={`${watch("portOfLoading") || "POL"} → ${watch("portOfDischarge") || "POD"}`}
                isCompleted={section4Completed}
                isOptional={false}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Port Details</p>
                </div>
                <div className="flex flex-row gap-[10px]">
                  <ActiveTabCH
                    callback={changeShipmentTypes}
                    selectedType={selectedType}
                  />
                </div>
              </div>
            )}
            {isMobile && (
              <MobileShipmentTypeTab
                selectedType={selectedType}
                callback={changeShipmentTypes}
                viewonly={cartingStore.disable}
              />
            )}
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-3">
                 <Box sx={{  width:"100%",height:"100%",gap:0 }}>
                  <Grid container rowSpacing={"4px"}>
                    <Grid item xs={12}>
                            <Typography variant="body1" style={{textAlign:"start",fontFamily:"Figtree",fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",}}>
        CFS Location *
      </Typography>
                            </Grid>
                            <Grid item xs={12}>
<Autocomplete
        value={selectedValue}
        onChange={(event, newValue) => handleSelectChange(newValue)}
        inputValue={inputValue}
        size="small"
        onInputChange={(event, newInputValue) => handleInputChange(newInputValue)}
        options={options}
        disabled={cartingStore.disable || cartingStore.update}
        freeSolo
        
        renderInput={(params) => (
          <CustomStyledTextField sx={{ "& .MuiOutlinedInput-root": {
                    "&.Mui-focused": {
                      fieldset: {
                        borderColor:`${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
                      },
                    },
                  }}}   size="small"    {...params} fullWidth error={!valid && (formValues['CFSLocation']==undefined || formValues['CFSLocation'].length==0)} helperText={(!valid && (formValues['CFSLocation']==undefined || formValues['CFSLocation'].length==0))?"Required":""}/>
        )}
      />
                            </Grid>
                  </Grid>
                  
      
    </Box>
</div>
              {[
                {
                  lable: "SHED Location",
                  type: "string",
                  name: "SHEDLocation",
                  rules:{}
                }
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              {/* <div className="column is-3">
                <AgSelectNewCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Carted At *"
                  name="portOfReceipt"
                  dataList={portlist}
                  callback={(e1) => {
                    setValue(`portOfReceipt`, e1);
                  }}
                  value={formValues["portOfReceipt"]}
                  isValid={getvaild('portOfReceipt')}
                  validationMsg={"* Please select an UN location"}
                />
              </div> */}
              <div className="column is-3">
                {isMobile ? (
                  <div className="flex flex-col w-full gap-[4px]">
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                      Carted At *
                    </p>
                    <AgMuiUn
                      country={true}
                      control={control}
                      name="portOfReceipt"
                      disabled={cartingStore.disable}
                      placeholder="Choose Carted At *"
                      rules={{ required: "Carted At is Required" }}
                      getValues={getValues}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      getFieldState={getFieldState}
                      validateAddress={false}
                      onChange={(val) => {
                        setValue("portOfReceipt", val);
                        if (cartingStore.current) cartingStore.current.portOfReceipt = val;
                        trigger("portOfReceipt");
                      }}
                    />
                  </div>
                ) : (
                  <AgUnlocCH
                    isDisabled={cartingStore.disable}
                    shipmentType={selectedType}
                    label="Carted At *"
                    name="portOfReceipt"
                    callback={(e1) => {
                      setValue(`portOfReceipt`, e1);
                    }}
                    callback2={(e1,list) => {
                      cartingStore.validation.portOfLoading = list.some(ele => ele === e1);
                    }}
                    value={formValues["portOfReceipt"]}
                    isValid={getvaild('portOfReceipt')}
                  />
                )}
              </div>
              <div className="column is-3">
                {isMobile ? (
                  <div className="flex flex-col w-full gap-[4px]">
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                      POL *
                    </p>
                    <AgMuiUn
                      country={true}
                      control={control}
                      name="portOfLoading"
                      disabled={cartingStore.disable}
                      placeholder="Choose POL *"
                      rules={{ required: "POL is Required" }}
                      getValues={getValues}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      getFieldState={getFieldState}
                      validateAddress={false}
                      onChange={(val) => {
                        setValue("portOfLoading", val);
                        if (cartingStore.current) cartingStore.current.portOfLoading = val;
                        trigger("portOfLoading");
                      }}
                    />
                  </div>
                ) : (
                  <AgUnlocCH
                    isDisabled={cartingStore.disable}
                    shipmentType={selectedType}
                    label="POL *"
                    name="portOfLoading"
                    callback={(e1) => {
                      setValue(`portOfLoading`, e1);
                    }}
                    callback2={(e1,list) => {
                      cartingStore.validation.portOfLoading = list.some(ele => ele === e1);
                    }}
                    value={formValues["portOfLoading"]}
                    isValid={getvaild('portOfLoading')}
                  />
                )}
              </div>
              {
                (selectedType.toLowerCase()=='lcl') ? (
                  <div className="column is-3">
                    {isMobile ? (
                      <div className="flex flex-col w-full gap-[4px]">
                        <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                          Routing
                        </p>
                        <AgMuiUn
                          country={true}
                          control={control}
                          name="reworkingPort"
                          disabled={cartingStore.disable}
                          placeholder="Choose Routing"
                          getValues={getValues}
                          clearErrors={clearErrors}
                          trigger={trigger}
                          getFieldState={getFieldState}
                          validateAddress={false}
                          onChange={(val) => {
                            setValue("reworkingPort", val);
                            if (cartingStore.current) cartingStore.current.reworkingPort = val;
                            trigger("reworkingPort");
                          }}
                        />
                      </div>
                    ) : (
                      <AgUnlocCH
                        isDisabled={cartingStore.disable}
                        shipmentType={selectedType}
                        label="Routing"
                        name="reworkingPort"
                        callback={(e1) => {
                          setValue(`reworkingPort`, e1);
                        }}
                        callback2={(e1,list) => {
                          cartingStore.validation.reworkingPort = list.some(ele => ele === e1);
                        }}
                        value={formValues["reworkingPort"]}
                        isValid={getvaild('reworkingPort',true,true)}
                      />
                    )}
                  </div>
                ) : ""
              }
              <div className="column is-3">
                {isMobile ? (
                  <div className="flex flex-col w-full gap-[4px]">
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                      POD *
                    </p>
                    <AgMuiUn
                      country={true}
                      control={control}
                      name="portOfDischarge"
                      disabled={cartingStore.disable}
                      placeholder="Choose POD *"
                      rules={{ required: "POD is Required" }}
                      getValues={getValues}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      getFieldState={getFieldState}
                      validateAddress={false}
                      onChange={(val) => {
                        setValue("portOfDischarge", val);
                        if (cartingStore.current) cartingStore.current.portOfDischarge = val;
                        trigger("portOfDischarge");
                      }}
                    />
                  </div>
                ) : (
                  <AgUnlocCH
                    isDisabled={cartingStore.disable}
                    shipmentType={selectedType}
                    label="POD *"
                    name="portOfDischarge"
                    callback={(e1) => {
                      setValue(`portOfDischarge`, e1);
                    }}
                    callback2={(e1,list) => {
                      cartingStore.validation.portOfDischarge = list.some(ele => ele === e1);
                    }}
                    value={formValues["portOfDischarge"]}
                    isValid={getvaild('portOfDischarge')}
                  />
                )}
              </div>
              <div className="column is-3">
                {isMobile ? (
                  <div className="flex flex-col w-full gap-[4px]">
                    <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                      FPOD *
                    </p>
                    <AgMuiUn
                      country={true}
                      control={control}
                      name="finalPlaceOfDelivery"
                      disabled={cartingStore.disable}
                      placeholder="Choose FPOD *"
                      rules={{ required: "FPOD is Required" }}
                      getValues={getValues}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      getFieldState={getFieldState}
                      validateAddress={false}
                      onChange={(val) => {
                        setValue("finalPlaceOfDelivery", val);
                        if (cartingStore.current) cartingStore.current.finalPlaceOfDelivery = val;
                        trigger("finalPlaceOfDelivery");
                      }}
                    />
                  </div>
                ) : (
                  <AgUnlocCH
                    isDisabled={cartingStore.disable}
                    shipmentType={selectedType}
                    label="FPOD *"
                    name="finalPlaceOfDelivery"
                    callback={(e1) => {
                      setValue(`finalPlaceOfDelivery`, e1);
                    }}
                    callback2={(e1,list) => {
                      cartingStore.validation.finalPlaceOfDelivery = list.some(ele => ele === e1);
                    }}
                    value={formValues["finalPlaceOfDelivery"]}
                    isValid={getvaild('finalPlaceOfDelivery')}
                  />
                )}
              </div>
              
              
              {(formValues["portOfReceipt"]!=undefined && formValues["portOfReceipt"].length>0 &&
                formValues["portOfLoading"]!=undefined && formValues["portOfLoading"].length>0 &&
                formValues["portOfReceipt"]!=formValues["portOfLoading"]
              ) && [
                {
                  lable: "ETA@POL",
                  type: "date",
                  name: "eta_at_pol",
                }
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              
            </div>
          </div>
          {!isMobile && <hr />}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={5}
                title="Cargo Details"
                subtitle={`${cargodetailsFromForm?.length || 1} line${(cargodetailsFromForm?.length || 1) > 1 ? "s" : ""} · ${isNaN(total.totTotalWeight) ? 0 : total.totTotalWeight} Kgs · ${isNaN(total.totTotalVolume) ? 0 : total.totTotalVolume} CBM`}
                isCompleted={section5Completed}
                isOptional={false}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Cargo Details</p>
                </div>
              </div>
            )}

            {isMobile ? (
              <MobileCargoDetailsView
                control={control}
                register={register}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
                errors={errors}
                mode={mode}
                cartingStore={cartingStore}
                reefer={reefer}
                overHeight={overHeight}
                overlength={overlength}
                topLoading={topLoading}
                fumigation={fumigation}
                headLoad={headLoad}
                doorLoad={doorLoad}
                hazardous={hazardous}
                nonStackable={nonStackable}
                cargodetailsFromForm={cargodetailsFromForm}
                cargoDetails={cargoDetails}
                appendCargo={appendCargo}
                removeCargo={removeCargo}
                total={total}
                isDimension={isDimension}
                weight={weight}
                totalWeight={totalWeight}
                totalVolume={totalVolume}
                dimensionsUnit={dimensionsUnit}
                generateId={generateId}
                validateGreaterThanZero={validateGreaterThanZero}
                calculateWeightAndVolume={calculateWeightAndVolume}
                LabelStyle={LabelStyle}
                DimensionLabelStyle={DimensionLabelStyle}
              />
            ) : (
              <>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row gap-[10px]">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label="Net Weight(Kgs) *"
                      control={control}
                      name="netWeight"
                      type="number"
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                </div>
                
                <CargoAttributesSwitches
                  isMobile={false}
                  control={control}
                  register={register}
                  disable={cartingStore.disable}
                  attributes={{
                    reefer,
                    overHeight,
                    overlength,
                    topLoading,
                    fumigation,
                    headLoad,
                    doorLoad,
                    hazardous,
                    nonStackable,
                  }}
                />
                <div className="w-full flex flex-row justify-between flex-wrap gap-2.5">
                  {hazardous && (
                    <DetailsSelect2
                      control={control}
                      name={"quoteClass"}
                      label={hazardous ? "Class *" : "Class"}
                      options={getHazardousClassList(mode.toUpperCase())}
                      disabled={cartingStore.disable}
                    />
                  )}
                  {hazardous && (
                    <DetailsText3
                    disabled={cartingStore.disable}
                      label={hazardous ? "UN Number *" : "UN Number"}
                      fontSize="12px"
                      size="small"
                      fullwidth
                      control={control}
                      name={"unnumber"}
                      type="text"
                    />
                  )}
                  {overHeight && (
                    <DetailsText3
                    disabled={cartingStore.disable}
                      label={overHeight ? "Over Height *": "Over Height"}
                      fontSize="12px"
                      size="small"
                      fullwidth
                      control={control}
                      name={"overHeightValue"}
                    />
                  )}
                  {overlength && (
                    <DetailsText3
                    disabled={cartingStore.disable}
                      label={overlength ? "Over length *" : "Over length"}
                      fontSize="12px"
                      size="small"
                      fullwidth
                      control={control}
                      name={"overlengthValue"}
                    />
                  )}
                </div>
                <div className="w-full flex flex-col gap-2 items-end">
                  <div
                    className={`flex flex-row w-full h-[35px] items-center border-[0.5px] border-solid border-[#D4D4D4] border-b-0 px-[12px]`}
                  >
                    <FlexibleCenteredDiv>
                      <TableHeading title="Package Type*" />
                    </FlexibleCenteredDiv>
                    <FlexibleCenteredDiv>
                      {" "}
                      <TableHeading title="Quantity *" />
                    </FlexibleCenteredDiv>
                    <FlexibleCenteredDiv>
                      <HeadingWithSelect
                      disabled={cartingStore.disable && !cartingStore.update}
                        onDropdownChange={() => {
                          //calculateWeightAndVolume();
                        }}
                        heading={
                          isDimension
                            ? mode === "lcl"
                              ? "Weight per package *"
                              : "Weight Per Piece *"
                            : "Total Weight *"
                        }
                        options={["Kgs", "Tons", "Lbs"]}
                        name={`cargoDetails.0.weight.unit`}
                        control={control}
                      />
                      {/* <TableHeading title={ (isDimension)? mode === "lcl" ? "Weight per package *" : "Weight Per Piece *" : "Total Weight *"} /> */}
                    </FlexibleCenteredDiv>
                    <div className={`flex flex-col flex-1`}>
                      {isDimension ? (
                        <div className="flex flex-row items-center justify-center w-[300px] gap-1 flex-1 ">
                          <TableHeading title="Dimensions* x" />
                          <AgMuiSelect2
                          disabled={cartingStore.disable && !cartingStore.update}
                            onChangeHandler={async () => {
                              //calculateWeightAndVolume();
                            }}
                            padding={0}
                            control={control}
                            name={"cargoDimensionUnit"}
                            size="small"
                            variant="standard"
                            disableUnderline={true}
                            values={["Cms", "MM", "Inches", "Meters", "Feet"]}
                            options={["Cms", "MM", "Inches", "Meters", "Feet"]}
                            fontColor="#555555"
                            iconColor="#555555"
                            style={{
                              fontSize: "12px",
                              alignItems: "center",
                              height: "25px",
                              // minWidth:"68px",
                              fontSize: "13px",
                              fontWeight: "bold",
                              color: "#555555",
                              borderLeft: 0,
                              padding: 0,
                              // paddingRight: "8px",
                              backgroundColor: "white",
                            }}
                          />
                        </div>
                      ) : (
                        <FlexibleCenteredDiv>
                          <HeadingWithSelect
                          disabled={cartingStore.disable && !cartingStore.update}
                            onDropdownChange={() => {
                              calculateWeightAndVolume();
                            }}
                            control={control}
                            name={`cargoDetails.0.totalVolume.unit`}
                            options={["CBM", "cu ft"]}
                            heading={"Total Volume*"}
                          />
                        </FlexibleCenteredDiv>
                      )}
                    </div>
                    {cargodetailsFromForm.length > 1 && (
                      <div className="w-[35px] h-full"></div>
                    )}
                  </div>
                  {cargodetailsFromForm.map((cargodetail, i) => (
                    <div
                      className={`flex flex-row w-full py-[8px] items-center px-[12px] ${
                        i % 2 === 0
                          ? "bg-[#F3F3F3]"
                          : "bg-white border-[0.5px] border-solid border-[#D4D4D4]"
                      }`}
                    >
                      <FlexibleCenteredDiv>
                        <AgMuiSelect2
                        disabled={cartingStore.disable && !cartingStore.update}
                          getValues={getValues}
                          key={generateId(cargodetail.id,i)}
                          style={{ height: "25px", width: "170px" }}
                          onChangeHandler={(value) => {}}
                          onBlur={() => {}}
                          rules={{ required: "Required" }}
                          size="small"
                          fontSize="12px"
                          options={packageTypeList}
                          control={control}
                          name={`cargoDetails.${i}.packageType`}
                        />
                      </FlexibleCenteredDiv>
                      <FlexibleCenteredDiv>
                        <Quantity
                        disabled={cartingStore.disable && !cartingStore.update}
                          onChange={() => {}}
                          getValues={getValues}
                          key={generateId(cargodetail.id,i)}
                          callback={(e) => {
                            setValue(`cargoDetails.${i}.quantity`, e);
                          }}
                          control={control}
                          name={`cargoDetails.${i}.quantity`}
                          rules={{
                            required: "Required",
                            validate: validateGreaterThanZero,
                          }}
                        />
                      </FlexibleCenteredDiv>
                      <FlexibleCenteredDiv>
                        {isDimension ? (
                          <TextWithSelect
                          disabled={cartingStore.disable && !cartingStore.update}
                            onChange={() => {}}
                            getValues={getValues}
                            key={generateId(cargodetail.id,i)}
                            name={`cargoDetails.${i}.weight.value`}
                            control={control}
                            unit={mode === "air" ? weight : totalWeight}
                            rules={{
                              required: "Required",
                              validate: (value) => {
                                let isValue = validateGreaterThanZero(value);
                                if (typeof isValue === "string") {
                                  return isValue;
                                } else if (mode !== "fcl") {
                                  return;
                                  let unit = getValues(
                                    `cargoDetails.0.weight.unit`
                                  );

                                  let maxValue =
                                    weightPerPackage[mode][unit.toLowerCase()];
                                  if (parseFloat(value) > maxValue) {
                                    // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                    return `value can't be greater than ${
                                      maxValue + " " + unit
                                    } `;
                                  }
                                }
                              },
                            }}
                          />
                        ) : (
                          <TextWithSelect
                          disabled={cartingStore.disable && !cartingStore.update}
                            onChange={() => {}}
                            getValues={getValues}
                            unit={totalWeight}
                            key={generateId(cargodetail.id,i)}
                            options={["Kgs", "Tons", "Lbs"]}
                            control={control}
                            name={`cargoDetails.${i}.totalWeight.value`}
                            selectName={`cargoDetails.0.totalWeight.unit`}
                            rules={{
                              required: "Required",
                              validate: (value) => {
                                let isValue = validateGreaterThanZero(value);
                                const totalWeight = getValues(
                                  `cargoDetails.0.totalWeight.unit`
                                );
                                if (typeof isValue === "string") {
                                  return isValue;
                                } else if (mode !== "fcl") {
                                  return;
                                  let l = Utils.toNum(cargodetail.quantity);
                                  if (l > 0) {
                                    let maxValue =
                                      l *
                                      weightPerPackage[mode][
                                        totalWeight.toLowerCase()
                                      ];
                                    if (parseFloat(value) > maxValue) {
                                      // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                      return `value can't be greater than ${
                                        maxValue + " " + totalWeight
                                      } `;
                                    }
                                  }
                                }
                              },
                            }}
                          />
                        )}
                      </FlexibleCenteredDiv>
                      {isDimension ? (
                        <FlexibleCenteredDiv className={`flex-none w-[300px]`}>
                          <div
                            key={generateId(cargodetail.id,i)}
                            className="flex flex-row w-full gap-1"
                          >
                            <LabeledTextField
                            disabled={cartingStore.disable}
                              onChange={() => {}}
                              textfieldStyles={DimensionLabelStyle}
                              rules={{
                                required: "Required",
                                validate: (value) => {
                                  let isValue = validateGreaterThanZero(value);
                                  if (typeof isValue === "string") {
                                    return isValue;
                                  } else if (mode !== "fcl") {
                                    return;
                                    let maxValue =
                                      maxDimensions[mode][
                                        dimensionsUnit.toLowerCase()
                                      ].length;

                                    if (value > maxValue) {
                                      // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                      return `value can't be greater than ${
                                        maxValue + " " + dimensionsUnit
                                      } `;
                                    }
                                  }
                                },
                              }}
                              control={control}
                              name={`cargoDetails.${i}.dimensions.length`}
                              endAdornment={<div className={LabelStyle}>L</div>}
                            />
                            <p>x</p>
                            <LabeledTextField
                            disabled={cartingStore.disable}
                              onChange={() => {}}
                              textfieldStyles={DimensionLabelStyle}
                              rules={{
                                required: "Required",
                                validate: (value) => {
                                  let isValue = validateGreaterThanZero(value);
                                  if (typeof isValue === "string") {
                                    return isValue;
                                  } else if (mode !== "fcl") {
                                    return;
                                    let maxValue =
                                      maxDimensions[mode][
                                        dimensionsUnit.toLowerCase()
                                      ].width;

                                    if (value > maxValue) {
                                      // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                      return `value can't be greater than ${
                                        maxValue + " " + dimensionsUnit
                                      } `;
                                    }
                                  }
                                },
                              }}
                              control={control}
                              name={`cargoDetails.${i}.dimensions.width`}
                              endAdornment={<div className={LabelStyle}>W</div>}
                            />
                            <p>x</p>
                            <LabeledTextField
                            disabled={cartingStore.disable}
                              onChange={() => {}}
                              textfieldStyles={DimensionLabelStyle}
                              rules={{
                                required: "Required",
                                validate: (value) => {
                                  let isValue = validateGreaterThanZero(value);
                                  if (typeof isValue === "string") {
                                    return isValue;
                                  } else if (mode !== "fcl") {
                                    return
                                    let maxValue =
                                      maxDimensions[mode][
                                        dimensionsUnit.toLowerCase()
                                      ].height;

                                    if (value > maxValue) {
                                      // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                      return `value can't be greater than ${
                                        maxValue + " " + dimensionsUnit
                                      } `;
                                    }
                                  }
                                },
                              }}
                              control={control}
                              name={`cargoDetails.${i}.dimensions.height`}
                              endAdornment={<div className={LabelStyle}>H</div>}
                            />
                          </div>{" "}
                        </FlexibleCenteredDiv>
                      ) : (
                        <FlexibleCenteredDiv>
                          {" "}
                          <TextWithSelect
                          disabled={cartingStore.disable && !cartingStore.update}
                            onChange={() => {}}
                            getValues={getValues}
                            unit={totalVolume}
                            key={generateId(cargodetail.id,i)}
                            options={["CBM", "cu ft"]}
                            rules={{
                              required: "Required",
                              validate: (value) => {
                                let isValue = validateGreaterThanZero(value);
                                const totalVolume = getValues(
                                  `cargoDetails.0.totalVolume.unit`
                                );
                                if (typeof isValue === "string") {
                                  return isValue;
                                } else if (mode !== "fcl") {
                                  return;
                                  let maxValue =
                                    lclWeightForPort["totalvolume"][
                                      totalVolume.toLowerCase()
                                    ];

                                  if (value > maxValue) {
                                    // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                    return `value can't be greater than ${
                                      maxValue + " " + totalVolume
                                    } `;
                                  }
                                }
                              },
                            }}
                            selectName={`cargoDetails.0.totalVolume.unit`}
                            control={control}
                            name={`cargoDetails.${i}.totalVolume.value`}
                          />
                        </FlexibleCenteredDiv>
                      )}
                      {
                        (cartingStore.disable==false  || cartingStore.update==true) && cargoDetails.length > 1 && (
                          <div
                            onClick={() => {
                              //  const currentType = getValues(`cargoDetails.${i}.packageType`);
                              //  if(currentType==="Loose Cartons"){
                              //      setValue("showPalletLabel",false)
                              //  }

                              removeCargo(i);
                            }}
                            className="w-[35px] h-full flex items-center justify-center cursor-pointer"
                          >
                            <img src={deleteicon} />
                          </div>
                        )
                        // : <CenteredBox sx={{width:"34px"}}/>
                      }
                    </div>
                  ))}

                  <div className="flex flex-row justify-between items-center w-full">
                    <div className="flex flex-col ">
          <div className="flex flex-row gap-2.5">
            <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl"? "Grand" : ""} Total Quantity :</p>
            <TextField
              variant="standard"
              value={isNaN(total.totNumPackages)?0:total.totNumPackages}
              fullWidth={false}
              sx={{
        width: `${String(total.totNumPackages || 0).length + 1}ch`,       
        minWidth: "20px",      
      }}
              InputProps={{
                disableUnderline: true,
                readOnly: false,
                 style:{
                    color:"#F4B14A",
                    fontWeight:"bold",
                    fontFamily:"Barlow"
                 }
              }}
            />
            {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
            </div>
         </div>
          <div className="flex flex-col">
               <div className="flex flex-row gap-2.5">
                  <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Weight:</p>
                  <TextField
                    {...register("grandTotalWeight", { validate:(value)=>{
                      let maxValue = lclWeightForPort.grandtotalweight["kgs"]
                       if(value > maxValue && mode.toLowerCase()==="lcl"){
                          return `value can't be greater than ${maxValue} Kgs.`
                       }
                    } })}
                    variant="standard"
                    value={isNaN(total.totTotalWeight)?0:total.totTotalWeight+ " " +"Kgs"}
                    fullWidth={false}
                    InputProps={{
                      disableUnderline: true,
                      readOnly: false,
                       style:{
                          color:"#F4B14A",
                          fontWeight:"bold",
                          fontFamily:"Barlow"
                       }
                    }}
                  />
                  {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
                  </div>
                  {errors.grandTotalWeight && <p className="text-[#d32f2f] text-sm">{errors.grandTotalWeight.message}</p>}
               </div>
                { !(mode==="air") &&  
                    <div className="flex flex-col">
                    <div className="flex flex-row gap-2.5">
                       <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Volume:</p>
                       <TextField
                         {...register("grandTotalVolume", { validate:(value)=>{
                          console.log("the value in volume is ",value)
                            let maxValue = lclWeightForPort.grandtotalvolume["cbm"]
                             if(value > maxValue && mode.toLowerCase()==="lcl"){
                                return `value can't be greater than ${maxValue} CBM.`
                             }
                         } })}
                         variant="standard"
                         value={isNaN(total.totTotalVolume)?0:total.totTotalVolume+ " " +"CBM"}
                         fullWidth={false}
                         InputProps={{
                           disableUnderline: true,
                           readOnly: false,
                            style:{
                               color:"#F4B14A",
                               fontWeight:"bold",
                               fontFamily:"Barlow"
                            }
                         }}
                       />
                       {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
                       </div>
                       {errors.grandTotalVolume && <p className="text-[#d32f2f] text-sm">{errors.grandTotalVolume.message}</p>}
                    </div>
                }
          { mode==="air" &&  
          <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Chargeable Weight:</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totChargeableWeight)?0:total.totChargeableWeight} Kgs</p></div>}
          { (cartingStore.disable==false || cartingStore.update==true) &&
        <button
                    onClick={() => {
                      let newCargo = new Cargo();
                      newCargo.totalVolume.unit = totalVolume;
                      newCargo.totalWeight.unit = totalWeight;
                      newCargo.weight.unit = weight;
                      appendCargo({ ...newCargo });
                    }}
                    type="button"
                    className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] w-[110px] rounded-[6px]"
                  >
                    <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
                      <Add
                        sx={{
                          fontSize: "22px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        }}
                      />
                      <p className="text-grey">Add Row</p>
                    </div>
                  </button>}
        </div>    
                </div>
              </>
            )}
          </div>
          {!isMobile && <hr />}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            {isMobile ? (
              <MobileSectionHeader
                index={6}
                title="Remarks"
                subtitle="Remarks / Special instructions"
                isCompleted={section6Completed}
                isOptional={true}
              />
            ) : (
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                  <img src={cargoDetail} />
                  <p className="text-black font-bold">Remarks</p>
                </div>
              </div>
            )}
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-12">
                <textarea
                disabled={cartingStore.disable}
                  ref={ref}
                  value={rsi}
                  onChange={(e) => {
                    setValue("remarks_special_instrctions", e.target.value);
                  }}
                  class="textarea"
                  placeholder="'Remarks / Special instrctions'"
                />
              </div>
            </div>
          </div>
          {!isMobile && <hr />}
          {isMobile && (
            <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px">
                 <MobileSectionHeader
              index={7}
              title="Required Documents"
              subtitle="Commercial Invoice, Packing List, Shipping Bill"
              isCompleted={section7Completed}
              isOptional={true}
            />
            <MobileRequiredDocumentsView
              cartingStore={cartingStore}
              filecat={filecat}
              delFile={delFile}
              renderLink={renderLink}
              fetchshippingBillchecklist={fetchshippingBillchecklist}
            />
            </div>
            
          )}
          {isMobile ? (
            <></>
          ) : (
            <div className="columns">
              <$c n="1"></$c>
              <$c n="9">
                <div className="table-container ">
                  <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                      <tr>
                        <th style={{ width: "16rem" }}>Required Documents</th>
                        <th>Document Uploaded</th>
                        {(cartingStore.disable==false || cartingStore.update==true) && <th style={{ width: "12rem" }}></th>}
                      </tr>
                    </thead>
                    <tbody>
                      <tr id="co1">
                        <td>
                          Commercial Invoice{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.commercialInvoice_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.commercialInvoice_filename_list =
                                        delFile(
                                          cartingStore.current.commercialInvoice_filename_list,
                                          i
                                        );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="commercialInvoice"
                            parent="co1"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.commercialInvoice_filename_list.push(filename)
                            }
                            withBtn={
                              cartingStore.current.commercialInvoice_filename_list.length > 0
                            }
                          />
                        </td>}
                      </tr>
                      <tr id="co2">
                        <td>
                          Packing List{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.packingList_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.packingList_filename_list = delFile(
                                        cartingStore.current.packingList_filename_list,
                                        i
                                      );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="packingList"
                            parent="co2"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.packingList_filename_list.push(filename)
                            }
                            withBtn={cartingStore.current.packingList_filename_list.length > 0}
                          />
                        </td>}
                      </tr>
                      <tr id="co3">
                        <td>
                          Shipping Bill{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.shippingBill_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.shippingBill_filename_list = delFile(
                                        cartingStore.current.shippingBill_filename_list,
                                        i
                                      );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="shippingBill"
                            parent="co3"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.shippingBill_filename_list.push(filename)
                            }
                            withBtn={cartingStore.current.shippingBill_filename_list.length > 0}
                          />
                        </td>}
                      </tr>
                      {cartingStore.current.cartingPhotos_filename_list!=undefined && <tr id="co4">
                        <td>
                          Carting photos{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.cartingPhotos_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.cartingPhotos_filename_list = delFile(
                                        cartingStore.current.cartingPhotos_filename_list,
                                        i
                                      );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="cartingPhotos"
                            parent="co4"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.cartingPhotos_filename_list.push(filename)
                            }
                            withBtn={cartingStore.current.cartingPhotos_filename_list.length > 0}
                          />
                        </td>}
                      </tr>}
                      {cartingStore.current.mmSlip_filename_list!=undefined && <tr id="co5">
                        <td>
                          MM Slip{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.mmSlip_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.mmSlip_filename_list = delFile(
                                        cartingStore.current.mmSlip_filename_list,
                                        i
                                      );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="mmSlip_filename"
                            parent="co5"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.mmSlip_filename_list.push(filename)
                            }
                            withBtn={cartingStore.current.mmSlip_filename_list.length > 0}
                          />
                        </td>}
                      </tr>}
                      {cartingStore.current.shippingBillchecklist_filename_list!=undefined && <tr id="co6">
                        <td>
                          Shipping Bill CheckList{" "}
                        </td>
                        <td
                        >
                          {cartingStore.current.shippingBillchecklist_filename_list
                            .map(renderLink)
                            .map((link, i) => (
                              <>
                                <p>
                                  {link}
                                  {(cartingStore.disable==false || cartingStore.update==true) && <span
                                    className="icon has-text-danger"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      cartingStore.current.shippingBillchecklist_filename_list = delFile(
                                        cartingStore.current.shippingBillchecklist_filename_list,
                                        i
                                      );
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </span>}
                                </p>
                                <br />
                              </>
                            ))}
                        </td>
                        {(cartingStore.disable==false || cartingStore.update==true) && <td>
                          <AgCustomFile
                            source="cartingorder"
                            cat={filecat}
                            filetype="cartingPhotos"
                            parent="co6"
                            multi={true}
                            callback={(filename) =>
                              cartingStore.current.shippingBillchecklist_filename_list.push(filename)
                            }
                            withBtn={cartingStore.current.shippingBillchecklist_filename_list.length > 0}
                          />
                          {
                            (cartingStore.current.shippingBillchecklist_filename_list.length > 0 &&
                            cartingStore.current.fetchshippingBillchecklist != cartingStore.current.shippingBillchecklist_filename_list[0]) && 
                            <div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={fetchshippingBillchecklist}
                    >
                      Fetch
                    </button>
                  </div>
                          }
                        </td>}
                      </tr>}
                    </tbody>
                  </table>
                </div>
              </$c>
            </div>
          )}
          {(cartingStore.disable==false || cartingStore.update==true) && <>
          { !isMobile && <hr />}
          {isMobile ? (
            <div className="flex flex-row justify-end items-center gap-3 w-full pb-4 rounded-2xl border-0 border-[#E2E8F0]">
              <button
                type="button"
                className="h-[38px] px-5 rounded-md border-0  text-blue-dark bg-white font-medium text-sm hover:bg-gray-50 active:scale-95 transition-all cursor-pointer"
                onClick={() => {
                  if (onClose) {
                    onClose();
                  } else {
                    AgmodalStore.pageVisible = false;
                    AgmodalStore.apiCall = true;
                  }
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="h-[38px] px-6 bg-blue-dark rounded-md text-white font-medium text-sm active:scale-95 transition-all cursor-pointer shadow-sm"
                style={{
                  backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                }}
                onClick={async (e) => {
                  const isValid = await trigger();
                  setValid(isValid);
                  if (isValid) {
                    handleSubmit(onSubmit)();
                  } else {
                    configStore.setModalMessage(`Please check the fields`);
                  }
                }}
              >
                Save
              </button>
            </div>
          ) : (
            <Columns>
              <Col12>
                <div
                  className="field is-grouped"
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {
                    (cartingStore.update==true)?<div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={async (e) => {
                        const isValid = await trigger();
                        setValid(isValid);
                        if (isValid ) {
                          handleSubmit(onSubmit)();
                        } else {
                          configStore.setModalMessage(`Please check the fields`);
                        }
                      }}
                    >
                      Update
                    </button>
                  </div>:<div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={async (e) => {
                        const isValid = await trigger();
                        setValid(isValid);
                        if (isValid ) {
                          handleSubmit(onSubmit)();
                        } else {
                          configStore.setModalMessage(`Please check the fields`);
                        }
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  }
                  
                  <div className="control">
                    <button
                      class="button is-danger"
                      onClick={() => {
                        if (onClose) {
                          onClose();
                        } else {
                          AgmodalStore.pageVisible = false;
                          AgmodalStore.apiCall = true;
                        }
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Col12>
            </Columns>
          )}
          </>}
        </>
      )}
    </>
  );
}
